// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:00:42.471Z
// Property: Malvern Hill Apartment Homes (ID: 6767906449167602)
// Collections: 21 amenities, 6 floorplans (live), 41 photos, 70 POIs, 1 reviews, 3 virtual tours, 5 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167602",
  "property_external_id": "1124172",
  "property_zillow_url": null,
  "property_apartments_url": null,
  "property_google_business_url": "https://www.google.com/maps/place/Malvern+Hill+Apartment+Homes/@39.0555246,-94.6132818,1777m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0ee2f75b8b519:0x98f77e72f2faf016!8m2!3d39.0555246!4d-94.6132818!16s%2Fg%2F1tdbrd24?entry=ttu&g_ep=EgoyMDI2MDkxNS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124172 p1099124",
  "property_status": null,
  "property_slug": "malvern-hill-apartment-homes",
  "property_name": "Malvern Hill Apartment Homes",
  "property_website_url": "https://www.malvernhillapts.com/",
  "property_domain": "https://www.malvernhillapts.com/",
  "property_address": "3942 Adams St #1",
  "property_full_address": "3942 Adams St #1, Kansas City, KS 66103",
  "property_address_1": "3942 Adams St",
  "property_address_2": "1",
  "property_address_city": "Kansas City",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66103",
  "property_address_country": "US",
  "property_address_county": "Wyandotte County",
  "property_neighborhood_address": "Rosedale",
  "property_address_latitude": "39.0555492",
  "property_address_longitude": "-94.61330339999999",
  "property_email": "rentcafe.mh@pricekc.com",
  "property_phone": "(913) 349-5968",
  "property_call_tracking_phone": "913-349-5968",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Comfort in the heart of Rosedale.</strong> Malvern Hill Apartment Homes offers studio and one-bedroom layouts with effortless everyday features, convenient community perks, and quick access to KU Medical Center, I-35, and downtown Kansas City—browse <a href=\"/floor-plans\">available floor plans</a> to find your next home.</p>",
  "property_long_description": "<p>Malvern Hill Apartment Homes offers <a href=\"/floor-plans\">studio, one-bedroom, and two-bedroom apartments</a> in Kansas City, Kansas. The <a href=\"/neighborhood\">community sits close</a> to the University of Kansas Medical Center and downtown Kansas City, putting work, dining, and Westport within easy reach.</p><p>Every <a href=\"/pet-policy\">pet-friendly</a> apartment includes ceiling fans, and residents have access to an outdoor resort-style pool and an on-site laundry facility. Controlled access doors and off-street parking, with garages available, are part of everyday life here.</p><p>Floor plans at Malvern Hill Apartment Homes go from cozy studios to spacious two-bedroom, two-bathroom homes, with finishes like stainless steel appliances and granite countertops available. Browse the full lineup on the <a href=\"/floor-plans\">Floor Plans page</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Malvern Hill Apartment Homes in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-298d-70fd-9644-5bc866074227.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
    "public_id": "01a0102a-298d-70fd-9644-5bc866074227",
    "storage_key": "property/6767906449167602/01a0102a-298d-70fd-9644-5bc866074227.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://malvernhillapts.securecafeapplicant.com/onlineleasing/content3/access/malvern-hill1/floorplans",
  "property_resident_portal_url": "https://malvernhillapts.securecafe.com/residentservices/malvern-hill1/userlogin.aspx",
  "property_apply_now_url": "https://malvernhillapts.securecafeapplicant.com/onlineleasing/content3/access/malvern-hill1/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-d313-710e-8250-051c7d9d3fa8.webp",
  "property_primary_logo_media": {
    "alt_text": "Malvern Hill Apartments logo",
    "public_id": "019fc97c-d313-710e-8250-051c7d9d3fa8",
    "storage_key": "property/6767906449167602/019fc97c-d313-710e-8250-051c7d9d3fa8.webp",
    "width": 1800,
    "height": 678
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97f-530d-7629-bb49-c2bec6478cdc.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc97f-530d-7629-bb49-c2bec6478cdc",
    "storage_key": "property/6767906449167602/019fc97f-530d-7629-bb49-c2bec6478cdc.webp",
    "width": 1280,
    "height": 482
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97f-1e96-72da-be49-6a74970e350e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc97f-1e96-72da-be49-6a74970e350e",
    "storage_key": "property/6767906449167602/019fc97f-1e96-72da-be49-6a74970e350e.webp",
    "width": 1280,
    "height": 482
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#003865",
  "property_secondary_color": "#D9C756",
  "property_font_color": null,
  "property_color_4": "#86BBD8",
  "property_color_3": "#BE4D00",
  "property_color_5": "#410B13",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "420 - 920",
  "property_sqft_min": "420",
  "property_sqft_max": "920",
  "property_price_range": "809 - 5327",
  "property_price_min": "809",
  "property_price_max": "5327",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/MalvernHillApts",
  "property_instagram_url": "https://www.instagram.com/malvernhillapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGbW4dS_uwIcRFvD68nJ-95g",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Malvern Hill Apartment Homes",
  "property_home_romance_title": "Embrace a Life You Love in Your New Apartment",
  "property_home_amenities_blurb": "<p><strong>Easy details, polished perks.</strong> Malvern Hill Apartment Homes brings everyday convenience together with relaxed extras, including off-street parking, available garages, controlled-access entries, a laundry facility, and an outdoor resort-style pool. Inside, studio and one-bedroom apartments feature all-electric kitchens, full-size refrigerators, dishwashers, upgraded cabinets and lighting, air conditioning, and select stainless steel appliances or patio/balcony spaces—plus pet-friendly benefits through the Pet Royalty Program.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose a floor plan that keeps life simple.</strong> Malvern Hill Apartment Homes offers efficient studios with electricity included in rent, plus comfortable one-bedroom layouts with extra room to spread out in Rosedale. Explore current pricing and availability, then look for everyday-friendly finishes like all-electric kitchens, full-size refrigerators, upgraded cabinets and light fixtures, air conditioning, and select homes with stainless steel appliances, ceiling fans, or a patio or balcony.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the look and feel of Malvern Hill.</strong> Browse bright studio and one-bedroom interiors with all-electric kitchens, upgraded cabinetry, and polished fixtures, plus select patios or balconies that bring in fresh air. Then take in landscaped grounds, controlled-access entries, and the resort-style pool built for easy afternoons in Kansas City, KS.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Rosedale puts Kansas City flavor close to home.</strong> From Malvern Hill Apartment Homes, take in hilltop views at the Rosedale Memorial Arch, walk the wooded Rozarks Trail, or make casual plans along Southwest Boulevard. Local staples like Dagwood’s Café, Rosedale Bar-B-Q, and Gus’s World Famous Fried Chicken are close by, with 39th Street and West 39th adding coffee, bookshops, and standout dining to the mix.</p>",
  "property_home_reviews_blurb": "<p><strong>Real feedback, everyday details.</strong> Reviews for Malvern Hill Apartment Homes point to what matters day to day: responsive management, clean and well-kept apartments, good parking, and a positively reviewed Rosedale setting.</p><p>Residents describe helpful service and comfortable living, with one calling their stay a “really great experience.” Read more to see what it’s like to call Malvern Hill home.</p>",
  "property_neighborhood_blurb": "<p><a href=\"/floor-plans\">Malvern Hill Apartment Homes</a> sits minutes from some of Kansas City's largest employers, including KU Medical Center, Truman Medical Center, and Saint Luke's Hospital, with the University of Missouri-Kansas City also nearby. Residents commuting to work or school have quick access to Interstate 35, HWY 71, and U.S. Route 169, plus KCATA bus routes for those who prefer public transit.</p><p>Beyond work, the neighborhood around Malvern Hill Apartment Homes offers plenty to explore. Roanoke Park and Rosedale Park are both close by for residents who want green space, and Science City at Union Station and LEGOLAND Discovery Center are popular nearby attractions. Westport and Downtown Kansas City are just minutes away for dining and nightlife, with grocery stores and everyday shopping close to home as well.</p><p>Want to see the neighborhood for yourself? Schedule a <a href=\"/schedule-a-tour\">tour</a> of Malvern Hill Apartment Homes and our team will show you around the community and the area.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Malvern Hill Apartment Homes is built around everyday convenience. Residents have access to an outdoor resort-style pool, an on-site laundry facility, and controlled access doors for added peace of mind. Off-street parking is available community-wide, with garages available for residents who want covered parking, and the community is within <a href=\"/neighborhood\">close reach of KU Medical Center</a>.</p><p>Inside each <a href=\"/floor-plans\">apartment</a>, residents will find an all-electric kitchen with stainless steel appliances, a dishwasher, and a full-size refrigerator. Granite countertops and upgraded cabinets and light fixtures are available in select homes, along with air conditioning, ceiling fans, and a private patio or balcony.</p><p>Curious what a home with these features looks like in person? Schedule a <a href=\"/schedule-a-tour\">tour</a> of Malvern Hill Apartment Homes and see the amenities for yourself.</p>",
  "property_applynow_blurb": "<p>Already a Malvern Hill Apartment Homes resident? This page is your starting point for managing your account online. From here, residents can pay rent, submit maintenance requests, and reach our office, all in one place.</p><p>Pay rent using a bank account or credit card, or sign up for flexible payment options through our partnership with Flex to split rent into smaller payments throughout the month. Need something repaired? Submit a work order right from your account and our maintenance team will take it from there. For after-hours emergencies, contact the office directly and follow the prompts to reach our answering service.</p><p>Log in to your resident account to get started, or contact our office during business hours if you need help accessing your account.</p>",
  "property_contactus_blurb": "<p>Have a question about Malvern Hill Apartment Homes? Our leasing team is here to help. Call or chat with us directly, or stop by the leasing office during business hours to speak with someone in person.</p>",
  "property_faqs_blurb": "<p>Have a question about renting at Malvern Hill Apartment Homes? Find answers above on <a href=\"http://malvernhillapts.securecafeapplicant.com/onlineleasing/content3/access/malvern-hill1/login\">applying</a>, <a href=\"/schedule-a-tour\">touring</a>, <a href=\"/pet-policy\">pets</a>, utilities, and day-to-day life in our <a href=\"/neighborhood\">Kansas City, KS</a> community. Still have a question? Contact our leasing office, and we will be happy to help.</p>",
  "property_floorplans_blurb": "<p>Malvern Hill Apartment Homes offers a range of floor plans designed to fit any lifestyle, from an efficient studio to a two-bedroom, two-bathroom layout. Every home includes an all-electric kitchen with a dishwasher and full-size refrigerator, plus a patio or balcony.</p><p>Studio apartments start around 420 square feet, offering an efficient layout that makes the most of every inch without sacrificing comfort. Our one-bedroom apartments in Kansas City, KS offer around 620 to 750 square feet of living space, with <a href=\"/amenities\">upgraded cabinets and light fixtures</a> available in select homes. Two-bedroom apartments range up to 920 square feet and are available in one- or two-bathroom layouts, giving residents room to spread out.</p><p>Take a <a href=\"/virtual-tours\">self-guided 360-degree tour</a> online or <a href=\"/schedule-a-tour\">schedule</a> a guided, in-person tour to find the floor plan that fits best at Malvern Hill Apartment Homes.</p>",
  "property_gallery_blurb": "<p>Take a closer look at life at Malvern Hill Apartment Homes. Browse photos of our <a href=\"/floor-plans\">studio, one-, and two-bedroom apartment</a> interiors, including kitchens, bedrooms, and bathrooms, to get a feel for the finishes and layouts available.</p><p>Beyond the apartment homes themselves, explore photos of the outdoor resort-style pool, the grounds, and the exterior of the community. When you are ready to see Malvern Hill Apartment Homes in person, <a href=\"/schedule-a-tour\">schedule a tour</a>, and our team will show you around.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Malvern Hill on the map.</strong> See available studio and one-bedroom apartments near Rosedale connections, with KU Medical Center, Rainbow Boulevard, Southwest Boulevard, I-35, dining, trails, and downtown Kansas City all within easy reach.</p>",
  "property_pets_blurb": "<p>Malvern Hill Apartment Homes welcomes cats, dogs, and rabbits, with up to two pets per apartment. We know pets are part of the family, so we built our pet-friendly community with easy outdoor access and nearby green space in mind.</p><p>Monthly pet rent is $25 per pet, and residents pay a one-time, non-refundable pet fee of $300 for one pet or $500 for two pets. Certain breeds, including Pit Bulls, Rottweilers, and German Shepherds, are restricted, along with exotic, feral, or wild animals. Contact the leasing office at Malvern Hill Apartment Homes for the full breed list and pet policy details before you apply.</p>",
  "property_referafriend_blurb": "<p><strong>Love living close to Rosedale?</strong> Share Malvern Hill Apartment Homes with a friend—comfortable studio and one-bedroom layouts, everyday conveniences, and quick access to KU Medical Center, I-35, neighborhood dining, and downtown Kansas City make it easy to recommend home.</p>",
  "property_residentaccess_blurb": "<p>Already a Malvern Hill Apartment Homes resident? This page is your starting point for managing your account online. From here, residents can pay rent, submit maintenance requests, and reach our office, all in one place.</p><p>Pay rent using a bank account or credit card, or sign up for flexible payment options through our partnership with Flex to split rent into smaller payments throughout the month. Need something repaired? Submit a work order right from your account and our maintenance team will take it from there. For after-hours emergencies, contact the office directly and follow the prompts to reach our answering service.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> Reviews of Malvern Hill Apartment Homes highlight the everyday details that make a difference: responsive management, a clean and well-kept apartment, good parking, and a setting in Rosedale that residents describe positively.</p><p>One resident called their stay a “really great experience,” noting that management was eager to help with issues and that the apartment was “very clean and well-kept.” As you browse ratings and feedback, you’ll get a real resident perspective on comfort, service, and what it’s like to call Malvern Hill Apartment Homes home.</p>",
  "property_created_at": "1785791764834",
  "property_scheduletour_blurb": "<p>Ready to see Malvern Hill Apartment Homes for yourself? Pick the tour option that fits your schedule. A guided, in-person tour with a member of our leasing team takes about 30 minutes and is a great way to ask questions and see <a href=\"/floor-plans\">available homes</a>. Prefer to look around on your own time? A <a href=\"/virtual-tours\">self-guided 360-degree virtual tour</a> is available on demand, so you can explore Malvern Hill Apartment Homes from anywhere.</p><p>To book a guided tour, select a date and time that works for you, let us know how many bedrooms you are interested in, and share your contact information. We look forward to showing you around.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon with next steps. In the meantime, Malvern Hill Apartment Homes keeps comfort and connection close with studio and one-bedroom layouts, everyday conveniences, and a Rosedale location minutes from KU Medical Center, local dining, and downtown Kansas City.</p>",
  "property_virtualtours_blurb": "<p>Can't make it to Kansas City just yet? Explore Malvern Hill Apartment Homes from wherever you are with our interactive 360-degree virtual tours. Step inside our <a href=\"/floor-plans\">Studio 1, Studio 2, and A2 floor plans</a> to see the layout, finishes, and natural light in each home before you ever set foot on the property.</p><p>When you are ready to see Malvern Hill Apartment Homes in person, <a href=\"/schedule-a-tour\">schedule a guided tour</a> or stop by during office hours. Our leasing team is happy to answer any questions.</p>",
  "property_copyright": "2026 All Rights Reserved. Malvern Hill Apartment Homes",
  "property_seo_title_home": "Malvern Hill | Apartments for Rent in Kansas City, KS",
  "property_seo_description_home": "Malvern Hill Apartment Homes offers studio, 1 & 2 bedroom apartments in Kansas City, KS near KU Medical Center. Tour our pet-friendly community today.",
  "property_seo_title_floorplans": "Studio, 1 & 2 Bedroom Apartments in Kansas City, KS",
  "property_seo_description_floorplans": "Explore studio, 1 & 2 bedroom floor plans at Malvern Hill Apartment Homes in Kansas City, KS. Compare layouts and square footage, then schedule a tour.",
  "property_seo_title_amenities": "Apartment Amenities in Kansas City, KS | Malvern Hill",
  "property_seo_description_amenities": "See the community and apartment amenities at Malvern Hill Apartment Homes in Kansas City, KS, from a resort-style pool to in-home laundry and more.",
  "property_seo_title_gallery": "Malvern Hill Apartment Homes Photos | Kansas City, KS",
  "property_seo_description_gallery": "Browse photos of apartment interiors, community amenities and the grounds at Malvern Hill Apartment Homes in Kansas City, KS. See it, then come visit.",
  "property_seo_title_virtualtours": "Malvern Hill Apartment Homes Virtual Tour | Kansas City",
  "property_seo_description_virtualtours": "Take a virtual tour of Malvern Hill Apartment Homes in Kansas City, KS from anywhere, then schedule an in-person visit when you are ready.",
  "property_seo_title_interactivemap": "Interactive Map | Malvern Hill Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Malvern Hill Apartment Homes in Kansas City! Choose from studios and one-bedrooms with resort-style amenities.",
  "property_seo_title_neighborhood": "Apartments Near KU Medical Center (KUMC) | Malvern Hill",
  "property_seo_description_neighborhood": "See what's near Malvern Hill Apartment Homes in Kansas City, KS, from KU Medical Center to Westport, plus transportation, parks and shopping nearby.",
  "property_seo_title_contact": "Contact Malvern Hill Apartment Homes | Kansas City, KS",
  "property_seo_description_contact": "Contact Malvern Hill Apartment Homes in Kansas City, KS. Call, chat, or stop by our leasing office. Find our address, phone number, and office hours here.",
  "property_seo_title_faqs": "Malvern Hill Apartment Homes FAQs | Kansas City, KS",
  "property_seo_description_faqs": "Get answers to common questions about applying, touring, pets, utilities, and more at Malvern Hill Apartment Homes in Kansas City, KS.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, KS",
  "property_seo_description_reviews": "Find out why residents at Malvern Hill in Kansas City love calling this community home! Read reviews and see what makes us stand out today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, KS",
  "property_seo_description_applynow": "Experience the Malvern Hill lifestyle in Kansas City with resort-style amenities, modern layouts, and pet-friendly options. Apply online now!",
  "property_seo_title_residentaccess": "Resident Portal | Malvern Hill Apartment Homes",
  "property_seo_description_residentaccess": "Manage your account at Malvern Hill Apartment Homes. Pay rent, submit maintenance requests, and more through our resident portal.",
  "property_seo_title_referafriend": "Refer A Friend | Malvern Hill Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Malvern Hill Apartment Homes in Kansas City, KS! Share the joy of vibrant living and enjoy the perks of great neighbors together!",
  "property_seo_title_scheduletour": "Schedule a Tour at Malvern Hill Apartment Homes",
  "property_seo_description_scheduletour": "Schedule a guided or self-guided tour of Malvern Hill Apartment Homes in Kansas City, KS. Pick a day and time that works for you and see it in person.",
  "property_seo_title_privacy": "Privacy Policy | Malvern Hill Apartment Homes",
  "property_seo_description_privacy": "At Malvern Hill Apartment Homes, your privacy matters. Discover our comprehensive privacy policy and secure your peace of mind today.",
  "property_seo_title_accessibility": "Website Accessibility | Malvern Hill Apartment Homes",
  "property_seo_description_accessibility": "At Malvern Hill Apartment Homes in Kansas City, we prioritize accessibility for all. Join us in fostering digital inclusion and a welcoming community.",
  "property_seo_title_sitemap": "Sitemap | Malvern Hill Apartment Homes",
  "property_seo_description_sitemap": "Unlock the full potential of Malvern Hill Apartment Homes in Kansas City, KS. Navigate our sitemap for a seamless experience in finding your perfect home!",
  "property_seo_title_thankyou": "Thank You | Malvern Hill Apartment Homes",
  "property_seo_description_thankyou": "Thank you for your interest in Malvern Hill Apartment Homes! Our team will reach out soon to help you discover your new home in vibrant Kansas City, KS.",
  "property_seo_title_pets": "Pet-Friendly Apartments in Kansas City, KS | Malvern Hill",
  "property_seo_description_pets": "Malvern Hill Apartment Homes welcomes cats, dogs, and rabbits in Kansas City, KS. Review our pet fees, pet rent, and breed guidelines before you apply.",
  "property_updated_at": "1793648359168",
  "amenities": [
    {
      "id": "ec_951c07d16a030040734d9596",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "120940213",
      "title": "Off-Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-468b-70f5-bfe0-43e0722fb14c.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding cityscape.",
        "public_id": "01a01029-468b-70f5-bfe0-43e0722fb14c",
        "storage_key": "property/6767906449167602/01a01029-468b-70f5-bfe0-43e0722fb14c.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "A cityscape with buildings and greenery under a clear sky. at Malvern Hill Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e6ba9016bb4038acabde3ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "120942376",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-458a-7670-99fc-019ed40f9add.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with attached garages under a clear blue sky.",
        "public_id": "01a01029-458a-7670-99fc-019ed40f9add",
        "storage_key": "property/6767906449167602/01a01029-458a-7670-99fc-019ed40f9add.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "A two-story building with a garage door and a driveway in front. at Malvern Hill Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd6df3f6659dcfc9a6136510",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091652",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ef78c262a1f0073ebbf6b3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091650",
      "title": "Controlled Access Doors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfab272c1783e692de43f46d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091653",
      "title": "Outdoor Resort-Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-4688-779a-b3e2-6ae7fa546ec9.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a sunset sky.",
        "public_id": "01a01029-4688-779a-b3e2-6ae7fa546ec9",
        "storage_key": "property/6767906449167602/01a01029-4688-779a-b3e2-6ae7fa546ec9.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "A swimming pool surrounded by a fence and buildings. at Malvern Hill Apartment Homes, Kansas,A patio with a table and chairs overlooking a pool. at Malvern Hill Apartment Homes, 66103,A black iron fence surrounds a small pool. at Malvern Hill Apartment Homes, 66103, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23a1b92d0d43fb2848e00956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "120940216",
      "title": "Proximity to KU Medical Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-45c6-75ab-b6ea-8719edd91ed4.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding cityscape with a distant skyline and a small swimming pool.",
        "public_id": "01a01029-45c6-75ab-b6ea-8719edd91ed4",
        "storage_key": "property/6767906449167602/01a01029-45c6-75ab-b6ea-8719edd91ed4.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "A cityscape with buildings and greenery under a clear sky. at Malvern Hill Apartment Homes, 66103, KS,The University of Kansas Health System building is a large, modern structure with a glass facade at Malvern Hill Apartment Homes, 66103",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_546d26e1f627b3b9d48f8d65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "120940264",
      "title": "Pet Royalty Program (Ask Our Office!)",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad2a18ff4d8020dc5638279f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "122755377",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8865a7b7839a6e139660618",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091644",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be606839496a3b3ef478fa83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091647",
      "title": "Electricity Included in Rent (Studios Only)*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8986cfd0ac66b1c767e4239e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88099992",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-47b7-770c-bcc6-75ac0eae7118.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel refrigerator, oven, and dishwasher.",
        "public_id": "01a01029-47b7-770c-bcc6-75ac0eae7118",
        "storage_key": "property/6767906449167602/01a01029-47b7-770c-bcc6-75ac0eae7118.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A kitchen with a stove, refrigerator, and microwave. at Malvern Hill Apartment Homes, 66103",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d8f6d66ede8f57e644c4ca3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091643",
      "title": "All-Electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-55d1-702e-ab26-bc9c6edcd041.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, white appliances, and laminate flooring.",
        "public_id": "01a01029-55d1-702e-ab26-bc9c6edcd041",
        "storage_key": "property/6767906449167602/01a01029-55d1-702e-ab26-bc9c6edcd041.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A kitchen with wooden cabinets and a granite countertop. at Malvern Hill Apartment Homes, 66103, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54fb676485408aa0f7d9ce62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "122010670",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-58ea-7596-b4c0-04b948619ed0.webp",
      "amenity_image_media": {
        "alt_text": "Open-concept living area and kitchen with stainless steel appliances and a sofa.",
        "public_id": "01a01029-58ea-7596-b4c0-04b948619ed0",
        "storage_key": "property/6767906449167602/01a01029-58ea-7596-b4c0-04b948619ed0.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern kitchen with dark wood cabinets and stainless steel appliances. at Malvern Hill Apartment Homes, 66103, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e3ac2faf8cdf801b4d2e310",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091648",
      "title": "Full-Size Refrigerators",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-47b7-770c-bcc6-75ac0eae7118.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel refrigerator, oven, and dishwasher.",
        "public_id": "01a01029-47b7-770c-bcc6-75ac0eae7118",
        "storage_key": "property/6767906449167602/01a01029-47b7-770c-bcc6-75ac0eae7118.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A kitchen with a stove, refrigerator, and microwave. at Malvern Hill Apartment Homes, Kansas,A kitchen with wooden cabinets and a granite countertop. at Malvern Hill Apartment Homes, 66103",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14dbb62393117d0f656e4dfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88099983",
      "title": "Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-59b2-7128-afd0-ac07a0ffc385.webp",
      "amenity_image_media": {
        "alt_text": "Private balcony with a small table, chairs, champagne, and flowers",
        "public_id": "01a01029-59b2-7128-afd0-ac07a0ffc385",
        "storage_key": "property/6767906449167602/01a01029-59b2-7128-afd0-ac07a0ffc385.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A wooden table with two chairs and a vase of flowers on a patio. at Malvern Hill Apartment Homes, 66103,A wooden table with a vase of flowers and a bottle on it. at Malvern Hill Apartment Homes, 66103, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be2f6dc73047bad654f12c3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "122010679",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c91665f79ba438d1ebbea5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "122010647",
      "title": "Upgraded Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-59bb-7416-80ea-023989be33e6.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom vanity with granite countertop, sink, and dark wood cabinets, adjacent to a bathtub and toilet.",
        "public_id": "01a01029-59bb-7416-80ea-023989be33e6",
        "storage_key": "property/6767906449167602/01a01029-59bb-7416-80ea-023989be33e6.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A bathroom with a white tub and wooden cabinets. at Malvern Hill Apartment Homes, 66103, KS,A kitchen with a stove, refrigerator, and cabinets. at Malvern Hill Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c0911ee7efc27c9c5b2ae71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "122010661",
      "title": "Upgraded Light Fixtures*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51d8413c685ac5621def1786",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091642",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce988bcfd55962dd93178e19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "88091645",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-5c13-7509-8737-d93596aba908.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, closet, and wall-mounted TV.",
        "public_id": "01a01029-5c13-7509-8737-d93596aba908",
        "storage_key": "property/6767906449167602/01a01029-5c13-7509-8737-d93596aba908.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A bedroom with a bed, a ceiling fan, and a clothing rack. at Malvern Hill Apartment Homes, 66103,A modern kitchen with a dining table and chairs. at Malvern Hill Apartment Homes, 66103, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2cb0c9afbb270175cb850f3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "external_id": "128899114",
      "title": "Upgraded White Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_c18e536344774c0c93ec3aad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-2e5b-75df-9476-d4e5341dae43.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, granite countertops, and bar seating.",
        "public_id": "01a01029-2e5b-75df-9476-d4e5341dae43",
        "storage_key": "property/6767906449167602/01a01029-2e5b-75df-9476-d4e5341dae43.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Step into this updated kitchen featuring ample cabinet space, granite countertops, and a breakfast bar perfect for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with wood cabinets, granite countertops, and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-3942 Adams St 1-1_final(1).jpg"
    },
    {
      "id": "ec_20f65e125ac0bc0a68aa9395",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-7311-737f-a88e-241dae833676.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with dining table and bar stools.",
        "public_id": "01a01029-7311-737f-a88e-241dae833676",
        "storage_key": "property/6767906449167602/01a01029-7311-737f-a88e-241dae833676.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area seamlessly connected to a modern kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Open concept living and kitchen area with dining table and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-3942 Adams St 1-6_final(1).jpg"
    },
    {
      "id": "ec_798fe9dd60a1e2a47c0f9e92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-7441-76e2-95db-8e071393cb0d.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, yellow accents, and a walk-in closet.",
        "public_id": "01a01029-7441-76e2-95db-8e071393cb0d",
        "storage_key": "property/6767906449167602/01a01029-7441-76e2-95db-8e071393cb0d.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious and stylish bedroom featuring a comfortable king-size bed, bright yellow bedding, and a convenient walk-in closet, perfect for modern living.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-size bed, yellow accents, and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-3942 Adams St 1-11_final.jpg"
    },
    {
      "id": "ec_45719a41a96e8db4a2ee6982",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-6cbf-75c6-b1a4-73add3488e91.webp",
      "image_media": {
        "alt_text": "Studio apartment with a queen bed, sofa, coffee table, and full kitchen.",
        "public_id": "01a01029-6cbf-75c6-b1a4-73add3488e91",
        "storage_key": "property/6767906449167602/01a01029-6cbf-75c6-b1a4-73add3488e91.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious studio apartment featuring a comfortable queen-size bed, a stylish sofa area, a modern coffee table, and a fully equipped kitchen for your convenience.",
      "link": "false",
      "alt_text": "Studio apartment with a queen bed, sofa, coffee table, and full kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-3942 Adams Suite 1 -4_final.jpg"
    },
    {
      "id": "ec_2eec08db9ca619f40d36206b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-6d30-772d-9455-55f21b362381.webp",
      "image_media": {
        "alt_text": "Studio apartment living area with kitchen, sofa, coffee table, and bed.",
        "public_id": "01a01029-6d30-772d-9455-55f21b362381",
        "storage_key": "property/6767906449167602/01a01029-6d30-772d-9455-55f21b362381.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space of this studio apartment, featuring a modern kitchen and a comfortable living area.",
      "link": "false",
      "alt_text": "Studio apartment living area with kitchen, sofa, coffee table, and bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-3942 Adams Suite 1 -1_final.jpg"
    },
    {
      "id": "ec_fa46373facbfe4bb0a9a04ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-7a78-750e-8662-5ffdf7195bab.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances, and granite countertops.",
        "public_id": "01a01029-7a78-750e-8662-5ffdf7195bab",
        "storage_key": "property/6767906449167602/01a01029-7a78-750e-8662-5ffdf7195bab.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample cabinet space, a full suite of appliances including a microwave and dishwasher, and a comfortable layout for meal preparation.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets, white appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-3942 Adams St 1-2_final.jpg"
    },
    {
      "id": "ec_7e46301174a7da95ec0629e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-831d-7759-81fa-faa7267acff1.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets and granite countertops, living room and stacked washer/dryer visible.",
        "public_id": "01a01029-831d-7759-81fa-faa7267acff1",
        "storage_key": "property/6767906449167602/01a01029-831d-7759-81fa-faa7267acff1.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen featuring ample wood cabinetry, granite countertops, and modern appliances. Enjoy the convenience of an in-unit stacked washer and dryer, and a welcoming living area perfect for relaxation.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets and granite countertops, living room and stacked washer/dryer visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-3942 Adams St 1-7_final(1).jpg"
    },
    {
      "id": "ec_7b32417b9c02b01d2dea70b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-8507-7471-b3a9-cde7d0528e59.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black microwave and stove, and granite countertops.",
        "public_id": "01a01029-8507-7471-b3a9-cde7d0528e59",
        "storage_key": "property/6767906449167602/01a01029-8507-7471-b3a9-cde7d0528e59.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring light wood cabinetry, a black microwave and stove, and durable granite countertops.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, black microwave and stove, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-3942 Adams St 1-3_final.jpg"
    },
    {
      "id": "ec_4d569f152330df4291988e05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-acdf-74ac-aaac-3afc0245d3ea.webp",
      "image_media": {
        "alt_text": "Modern living room with white walls, wood floors, and French doors.",
        "public_id": "01a01029-acdf-74ac-aaac-3afc0245d3ea",
        "storage_key": "property/6767906449167602/01a01029-acdf-74ac-aaac-3afc0245d3ea.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Relax in this stylish living room featuring sleek furniture, modern art, and abundant natural light.",
      "link": "false",
      "alt_text": "Modern living room with white walls, wood floors, and French doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-3942 Adams St 1-5_final.jpg"
    },
    {
      "id": "ec_5c08188cbbc33e8c45eef73b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-a75d-70b8-8f39-918a94433cf8.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, a closet, and a TV mounted on the wall.",
        "public_id": "01a01029-a75d-70b8-8f39-918a94433cf8",
        "storage_key": "property/6767906449167602/01a01029-a75d-70b8-8f39-918a94433cf8.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, ample closet space, and a wall-mounted TV. Enjoy a relaxing retreat in this beautifully appointed room.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, a closet, and a TV mounted on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-3942 Adams St 1-9_final(1).jpg"
    },
    {
      "id": "ec_b285262e722e828bc8e8d19d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-ac8c-74ba-a833-bb8da6eeda77.webp",
      "image_media": {
        "alt_text": "King size bed with yellow and grey bedding, large TV, ceiling fan, and doorway to bathroom.",
        "public_id": "01a01029-ac8c-74ba-a833-bb8da6eeda77",
        "storage_key": "property/6767906449167602/01a01029-ac8c-74ba-a833-bb8da6eeda77.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with stylish bedding, a wall-mounted TV, a ceiling fan, and an en-suite bathroom.",
      "link": "false",
      "alt_text": "King size bed with yellow and grey bedding, large TV, ceiling fan, and doorway to bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-3942 Adams St 1-8_final.jpg"
    },
    {
      "id": "ec_f628da3267855da65760adb5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-bce5-74d7-8f49-b0267391f17c.webp",
      "image_media": {
        "alt_text": "Closet with wire shelving and hanging clothes.",
        "public_id": "01a01029-bce5-74d7-8f49-b0267391f17c",
        "storage_key": "property/6767906449167602/01a01029-bce5-74d7-8f49-b0267391f17c.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space for your wardrobe.",
      "link": "false",
      "alt_text": "Closet with wire shelving and hanging clothes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-3942 Adams St 1-12_final.jpg"
    },
    {
      "id": "ec_d6efdb0000579ff94937cf1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-b3e9-7689-84a8-461b05c72cf6.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, closet, and wall-mounted TV.",
        "public_id": "01a01029-b3e9-7689-84a8-461b05c72cf6",
        "storage_key": "property/6767906449167602/01a01029-b3e9-7689-84a8-461b05c72cf6.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a convenient walk-in closet, a modern ceiling fan, and a wall-mounted television for entertainment.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, closet, and wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-3942 Adams St 1-10_final(1).jpg"
    },
    {
      "id": "ec_89071658e299a64624325d8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-d32c-7130-84b4-e774c46bc569.webp",
      "image_media": {
        "alt_text": "Sliding glass door leading to a patio with a table set for two with champagne and flowers.",
        "public_id": "01a01029-d32c-7130-84b4-e774c46bc569",
        "storage_key": "property/6767906449167602/01a01029-d32c-7130-84b4-e774c46bc569.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy your private patio oasis, perfect for intimate gatherings or a quiet evening with a bottle of champagne and a loved one.",
      "link": "false",
      "alt_text": "Sliding glass door leading to a patio with a table set for two with champagne and flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-3942 Adams St 1-17_final.jpg"
    },
    {
      "id": "ec_5c4e515f6c237014105b957c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-e9d3-719c-a405-657199632926.webp",
      "image_media": {
        "alt_text": "Patio with table, chairs, and champagne.",
        "public_id": "01a01029-e9d3-719c-a405-657199632926",
        "storage_key": "property/6767906449167602/01a01029-e9d3-719c-a405-657199632926.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drinks on your private patio, complete with a table, chairs, and a touch of luxury.",
      "link": "false",
      "alt_text": "Patio with table, chairs, and champagne.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-3942 Adams St 1-16_final(2).jpg"
    },
    {
      "id": "ec_f9d7b95ce2286a6ee8752651",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-dfb9-74ed-b6fb-37eba7635d38.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, sink, and shower.",
        "public_id": "01a01029-dfb9-74ed-b6fb-37eba7635d38",
        "storage_key": "property/6767906449167602/01a01029-dfb9-74ed-b6fb-37eba7635d38.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a toilet, vanity with a sink, and a shower/tub combo with a stylish shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, sink, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-3942 Adams St 1-13_final.jpg"
    },
    {
      "id": "ec_3c89992403bec165bce96faa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-ea34-7432-8368-09ebd7a05b61.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and storage",
        "public_id": "01a01029-ea34-7432-8368-09ebd7a05b61",
        "storage_key": "property/6767906449167602/01a01029-ea34-7432-8368-09ebd7a05b61.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bathroom vanity featuring a sink, ample counter space, and storage cabinets. Includes a large mirror and bright vanity lighting.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, and storage",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-3942 Adams St 1-15_final.jpg"
    },
    {
      "id": "ec_f476a86227863ed8e5222ee5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-f39b-762b-8085-384c84d8f04f.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and granite countertops.",
        "public_id": "01a01029-f39b-762b-8085-384c84d8f04f",
        "storage_key": "property/6767906449167602/01a01029-f39b-762b-8085-384c84d8f04f.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring a full suite of white appliances including a refrigerator, dishwasher, microwave, and oven, complemented by warm wood cabinetry and elegant granite countertops.",
      "link": "false",
      "alt_text": "Kitchen with white appliances, wood cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-3942 Adams St 1-4_final.jpg"
    },
    {
      "id": "ec_c05d9f3b07648d7052661469",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-00f9-718a-af10-c67ffd9267a1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and shower with blue ombre curtain.",
        "public_id": "01a0102a-00f9-718a-af10-c67ffd9267a1",
        "storage_key": "property/6767906449167602/01a0102a-00f9-718a-af10-c67ffd9267a1.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a wood vanity with ample counter space, a large mirror, a toilet, and a shower with a stylish blue ombre curtain. The wood-look flooring adds warmth to the space.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and shower with blue ombre curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-3942 Adams St 1-14_final.jpg"
    },
    {
      "id": "ec_00fa538fedf15d46ca55b4be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-014f-7400-92ed-79528d1bede8.webp",
      "image_media": {
        "alt_text": "Open-concept studio apartment living area with kitchen and closet.",
        "public_id": "01a0102a-014f-7400-92ed-79528d1bede8",
        "storage_key": "property/6767906449167602/01a0102a-014f-7400-92ed-79528d1bede8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "View of a studio apartment showing a living area with a sofa and coffee table, an open kitchen with dark wood cabinets, and a closet with organized clothes.",
      "link": "false",
      "alt_text": "Open-concept studio apartment living area with kitchen and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-3942 Adams Suite 1 -5_final.jpg"
    },
    {
      "id": "ec_7d40a7279a8be98f51497ec3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-13a1-746a-acaf-9986d54639cc.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "01a0102a-13a1-746a-acaf-9986d54639cc",
        "storage_key": "property/6767906449167602/01a0102a-13a1-746a-acaf-9986d54639cc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "This kitchen features dark wood cabinetry, granite countertops, a stainless steel refrigerator, and a black stove. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-3942 Adams Suite 1 -3_final.jpg"
    },
    {
      "id": "ec_cc9fdea4e0936a6975b0012c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-159b-710d-9e9c-fb1b695e23a5.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop and dark wood cabinets, and a bathtub with toilet.",
        "public_id": "01a0102a-159b-710d-9e9c-fb1b695e23a5",
        "storage_key": "property/6767906449167602/01a0102a-159b-710d-9e9c-fb1b695e23a5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a spacious vanity with granite countertops and dark wood cabinetry, complemented by a white bathtub and toilet for a fresh feel.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop and dark wood cabinets, and a bathtub with toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-3942 Adams Suite 1 -6_final.jpg"
    },
    {
      "id": "ec_c5d0c8ab17f51305b157428d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-1b7e-76c2-9b00-7c95b2f898a0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "01a0102a-1b7e-76c2-9b00-7c95b2f898a0",
        "storage_key": "property/6767906449167602/01a0102a-1b7e-76c2-9b00-7c95b2f898a0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen, featuring sleek stainless steel appliances, dark wood cabinetry, and elegant granite countertops. Perfect for preparing your favorite meals.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-3942 Adams Suite 1 -2_final.jpg"
    },
    {
      "id": "ec_c8a6c42a94e5cd74f4ad6463",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-1e8c-739b-8244-6f3d35d2326e.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, dark wood cabinets, sink, and mirror reflecting a kitchen.",
        "public_id": "01a0102a-1e8c-739b-8244-6f3d35d2326e",
        "storage_key": "property/6767906449167602/01a0102a-1e8c-739b-8244-6f3d35d2326e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom vanity featuring a granite countertop, dark wood cabinetry, and ample storage. The vanity includes a sink, mirror, and towel racks.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop, dark wood cabinets, sink, and mirror reflecting a kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-3942 Adams Suite 1 -7_final.jpg"
    },
    {
      "id": "ec_cf99ab041190e4ad6bc29aab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-4688-779a-b3e2-6ae7fa546ec9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a sunset sky.",
        "public_id": "01a01029-4688-779a-b3e2-6ae7fa546ec9",
        "storage_key": "property/6767906449167602/01a01029-4688-779a-b3e2-6ae7fa546ec9.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, perfect for a refreshing dip on a warm day. Enjoy the beautiful sunset views from the comfortable lounge chairs.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a sunset sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-DSC09960 VT.jpg"
    },
    {
      "id": "ec_45b034f0347e68979a0c17d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-24b0-75b8-8077-5f8d1c50904d.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with green grass and parking lot.",
        "public_id": "01a0102a-24b0-75b8-8077-5f8d1c50904d",
        "storage_key": "property/6767906449167602/01a0102a-24b0-75b8-8077-5f8d1c50904d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Charming apartment building exterior with well-maintained landscaping and convenient parking. A welcoming entrance leads to your new home.",
      "link": "false",
      "alt_text": "Exterior view of the apartment building with green grass and parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-DSC00166.jpg"
    },
    {
      "id": "ec_58d3833de50c39ccaaf956c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-24a9-7109-829f-8a14abb1be6f.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with leasing office entrance and parking.",
        "public_id": "01a0102a-24a9-7109-829f-8a14abb1be6f",
        "storage_key": "property/6767906449167602/01a0102a-24a9-7109-829f-8a14abb1be6f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, including the leasing office entrance, accessible parking, and surrounding parking lot.",
      "link": "false",
      "alt_text": "Exterior of apartment building with leasing office entrance and parking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-DSC00051-Edit-Edit.jpg"
    },
    {
      "id": "ec_101704d4edbaaacb0009d76f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-2978-771a-a02e-4d8a386a5ff4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
        "public_id": "01a0102a-2978-771a-a02e-4d8a386a5ff4",
        "storage_key": "property/6767906449167602/01a0102a-2978-771a-a02e-4d8a386a5ff4.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and seating areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-DJI_20250723095918_0717_D.jpg"
    },
    {
      "id": "ec_bab26404f80b2fc7c7e17184",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-298d-70fd-9644-5bc866074227.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
        "public_id": "01a0102a-298d-70fd-9644-5bc866074227",
        "storage_key": "property/6767906449167602/01a0102a-298d-70fd-9644-5bc866074227.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and convenient seating for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC09979.jpg"
    },
    {
      "id": "ec_157b45244f459c7a53224480",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-2b21-71ca-93ba-75c2e2ac1d0b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a fenced perimeter.",
        "public_id": "01a0102a-2b21-71ca-93ba-75c2e2ac1d0b",
        "storage_key": "property/6767906449167602/01a0102a-2b21-71ca-93ba-75c2e2ac1d0b.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the community's sparkling outdoor swimming pool, surrounded by comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a fenced perimeter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-DSC00006-Edit.jpg"
    },
    {
      "id": "ec_64afdcc6aad0c65e73797797",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-458a-7670-99fc-019ed40f9add.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with attached garages under a clear blue sky.",
        "public_id": "01a01029-458a-7670-99fc-019ed40f9add",
        "storage_key": "property/6767906449167602/01a01029-458a-7670-99fc-019ed40f9add.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Exterior view of a cream-colored apartment building with attached garages, set against a backdrop of a clear blue sky with scattered clouds.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with attached garages under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-DSC00076-Edit.jpg"
    },
    {
      "id": "ec_ec1ab8a7bef4b1b01ed12096",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-33e9-72fa-ba84-cd7a14e87392.webp",
      "image_media": {
        "alt_text": "Exterior of the apartment building with a parking lot in front.",
        "public_id": "01a0102a-33e9-72fa-ba84-cd7a14e87392",
        "storage_key": "property/6767906449167602/01a0102a-33e9-72fa-ba84-cd7a14e87392.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "This image shows the exterior of the apartment building, featuring its brick facade and a well-maintained parking lot filled with cars. The building is surrounded by greenery, under a clear blue sky.",
      "link": "false",
      "alt_text": "Exterior of the apartment building with a parking lot in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-DSC00091-Edit.jpg"
    },
    {
      "id": "ec_5697bfd08ab8d153d85aa36f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-3f7e-77ce-9049-01b835dcd63d.webp",
      "image_media": {
        "alt_text": "Entrance hall with closet and front door",
        "public_id": "01a0102a-3f7e-77ce-9049-01b835dcd63d",
        "storage_key": "property/6767906449167602/01a0102a-3f7e-77ce-9049-01b835dcd63d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Hallway leading to the apartment entrance, featuring a spacious closet with sliding doors and wood-look flooring.",
      "link": "false",
      "alt_text": "Entrance hall with closet and front door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Malvern_Hill_019_Photo_Studio2_Closet1_2026-04-29_v1-0.png"
    },
    {
      "id": "ec_64d8a42ce1b70be056412368",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-4821-7236-b8eb-10636729fb3d.webp",
      "image_media": {
        "alt_text": "Kitchenette with white stove, dual sinks, dark wood cabinets, and a ceiling fan.",
        "public_id": "01a0102a-4821-7236-b8eb-10636729fb3d",
        "storage_key": "property/6767906449167602/01a0102a-4821-7236-b8eb-10636729fb3d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Compact kitchenette featuring a white stove, dual sinks, ample cabinet space, and a ceiling fan, perfect for efficient living.",
      "link": "false",
      "alt_text": "Kitchenette with white stove, dual sinks, dark wood cabinets, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Malvern_Hill_019_Photo_Studio2_Kitchen2_2026-04-29_v1-0.png"
    },
    {
      "id": "ec_c0ff69fdb440347e2dcba6ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-464b-726f-bcca-05f5f55d8f77.webp",
      "image_media": {
        "alt_text": "Closet with sliding doors and shelves",
        "public_id": "01a0102a-464b-726f-bcca-05f5f55d8f77",
        "storage_key": "property/6767906449167602/01a0102a-464b-726f-bcca-05f5f55d8f77.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious closet with built-in shelving and sliding doors, perfect for storage.",
      "link": "false",
      "alt_text": "Closet with sliding doors and shelves",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Malvern_Hill_019_Photo_Studio2_Closet2_2026-04-29_v1-0.png"
    },
    {
      "id": "ec_968ea0d1cd989d1c992bacc2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a060c9-3b7e-73aa-aeae-5d5e2fdb2c32.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, closet, and a desk.",
        "public_id": "01a060c9-3b7e-73aa-aeae-5d5e2fdb2c32",
        "storage_key": "property/6767906449167602/01a060c9-3b7e-73aa-aeae-5d5e2fdb2c32.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Comfortable and stylish bedroom featuring a queen-size bed, ample closet space, and a functional desk area.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, closet, and a desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/content (2).jpg"
    },
    {
      "id": "ec_64aa6be038ed1ec39afa5167",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-578e-76e0-bdcc-1fc764b618a4.webp",
      "image_media": {
        "alt_text": "Interior view of a carpeted apartment living area with a closet and kitchen area.",
        "public_id": "01a0102a-578e-76e0-bdcc-1fc764b618a4",
        "storage_key": "property/6767906449167602/01a0102a-578e-76e0-bdcc-1fc764b618a4.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious living area with carpet flooring and a well-equipped kitchen featuring dark wood cabinets and stainless steel appliances.",
      "link": "false",
      "alt_text": "Interior view of a carpeted apartment living area with a closet and kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Malvern_Hill_019_Photo_Studio1_LivingArea3_2026-04-29_v1-0.png"
    },
    {
      "id": "ec_7cfd40bac8f8cb9178846926",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-6d1a-74ca-8583-b575fd6c7600.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances including a refrigerator, dishwasher, and stove, and granite countertops.",
        "public_id": "01a0102a-6d1a-74ca-8583-b575fd6c7600",
        "storage_key": "property/6767906449167602/01a0102a-6d1a-74ca-8583-b575fd6c7600.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in this beautifully appointed kitchen, featuring dark wood cabinetry, sleek granite countertops, and a full suite of stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances including a refrigerator, dishwasher, and stove, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Malvern_Hill_019_Photo_Studio1_Kitchen_2026-04-29_v1-0.png"
    },
    {
      "id": "ec_2172307d5fc06cb89bb8284f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-8610-7428-b12f-03d9e33d1eda.webp",
      "image_media": {
        "alt_text": "Living room with closet and open-concept kitchen view.",
        "public_id": "01a0102a-8610-7428-b12f-03d9e33d1eda",
        "storage_key": "property/6767906449167602/01a0102a-8610-7428-b12f-03d9e33d1eda.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious living area with a sliding closet and an open-concept kitchen featuring modern appliances and dark cabinetry.",
      "link": "false",
      "alt_text": "Living room with closet and open-concept kitchen view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Malvern_Hill_019_Photo_Studio1_LivingArea2_2026-04-29_v1-0.png"
    },
    {
      "id": "ec_0260e8cde3f0d9db3195435a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-90b1-764d-8e28-ac084c5b880f.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, and a view into a bedroom.",
        "public_id": "01a0102a-90b1-764d-8e28-ac084c5b880f",
        "storage_key": "property/6767906449167602/01a0102a-90b1-764d-8e28-ac084c5b880f.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a modern vanity and sink, leading into a carpeted bedroom.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and mirror, and a view into a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Malvern_Hill_019_Photo_Studio1_BathroomSink_2026-04-29_v1-0.png"
    },
    {
      "id": "ec_b7c0b616bf370dca1c815271",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-9a84-74d8-a875-7316088fe75b.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, and tub/shower combo.",
        "public_id": "01a0102a-9a84-74d8-a875-7316088fe75b",
        "storage_key": "property/6767906449167602/01a0102a-9a84-74d8-a875-7316088fe75b.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with a large framed mirror, a sleek sink, and a separate tub and shower area.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, mirror, and tub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Malvern_Hill_019_Photo_Studio2_Bathroom_2026-04-29_v1-0.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_696a70ba-16fa-4603-bf8c-3264e2f450c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "3928 Rainbow Blvd, Kansas City, KS 66103, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f6e3-710c-9fab-b679136f957e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f6e3-710c-9fab-b679136f957e",
        "storage_key": "property/6767906449167602/01a01014-f6e3-710c-9fab-b679136f957e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/ks/kansas-city/breakfast-3928-rainbow-blvd.-2124?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=2124&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2484000263902926190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "39.0563174",
      "poi_longitude": "-94.6121791",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-948-6222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl5_qGC_uwIcRbhXpRxTxeCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_24f01a56-68ce-4ce2-aa4e-65e1b0b84525",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Joe's KC BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3002 W 47th Ave, Kansas City, KS 66103, USA",
      "poi_short_description": "Relaxed BBQ pit stop for slabs of ribs, pulled pork sandwiches, meat by the pound & sides.",
      "poi_long_description": "Relaxed BBQ pit stop for slabs of ribs, pulled pork sandwiches, meat by the pound & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97b-ec46-77d6-b252-caa04000ad52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97b-ec46-77d6-b252-caa04000ad52",
        "storage_key": "property/6767906449167602/019fc97b-ec46-77d6-b252-caa04000ad52.webp",
        "width": 1280,
        "height": 445
      },
      "poi_business_url": "https://www.joeskc.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=1535412546490701816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joes-kc-bbq",
      "poi_latitude": "39.0444482",
      "poi_longitude": "-94.6207405",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-722-3366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeelZFz_uwIcR-JdBeZPhThU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_4d7457ed-43ab-4ce7-9e3a-9ee76f67855a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Gus's World Famous Fried Chicken",
      "poi_type": "Restaurants",
      "poi_address": "2816 W 47th Ave, Kansas City, KS 66103, USA",
      "poi_short_description": "Long-running chain serving spicy fried chicken & comfort sides in a low-key setting.",
      "poi_long_description": "Long-running chain serving spicy fried chicken & comfort sides in a low-key setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-833b-7571-81ec-5d574a6e13df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-833b-7571-81ec-5d574a6e13df",
        "storage_key": "property/6767906449167602/019ff6b8-833b-7571-81ec-5d574a6e13df.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://gusfriedchicken.com/kc-kansas-city-ks-location/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14961880856613662923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guss-world-famous-fried-chicken",
      "poi_latitude": "39.0445415",
      "poi_longitude": "-94.6191914",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-232-7091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZCg0zjuwIcRy7AsHl5Ho88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_95001f08-4f07-4cb9-9ad5-d772a1141254",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Rosedale Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "600 Southwest Blvd, Kansas City, KS 66103, USA",
      "poi_short_description": "Longtime restaurant doling out slow-smoked, Kansas City-style BBQ classics in a down-home setting.",
      "poi_long_description": "Longtime restaurant doling out slow-smoked, Kansas City-style BBQ classics in a down-home setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-3337-711f-bfc1-fed1ddce7da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-3337-711f-bfc1-fed1ddce7da7",
        "storage_key": "property/6767906449167602/019fc980-3337-711f-bfc1-fed1ddce7da7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rosedalebarbeque.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16729713698989451010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosedale-bar-b-q",
      "poi_latitude": "39.0658054",
      "poi_longitude": "-94.6161772",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-262-0343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwzMUtjxwIcRAqdArvjhK-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_d002835a-bf55-4d97-a362-e1c7e75abab1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Q39 - Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1000 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Hip, airy joint with beamed ceilings & exposed brick serving smoked BBQ & wood-fired meats.",
      "poi_long_description": "Hip, airy joint with beamed ceilings & exposed brick serving smoked BBQ & wood-fired meats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97b-eea8-748c-9448-85af8a659ec4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97b-eea8-748c-9448-85af8a659ec4",
        "storage_key": "property/6767906449167602/019fc97b-eea8-748c-9448-85af8a659ec4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://q39kc.com/locations/kansas-city-bbq/?utm_source=Google&utm_medium=Maps&utm_campaign=GBP_midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504754235694060525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "q39---midtown",
      "poi_latitude": "39.0573424",
      "poi_longitude": "-94.5982173",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-255-3753",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ541xZ9HvwIcR7RNf2s_QZEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_051bd041-5dbb-4eb7-9028-b28dc633ac93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "KC Smoke Burger",
      "poi_type": "Restaurants",
      "poi_address": "1610 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Casual restaurant with eclectic decor serving smoked burgers, plus cheesesteaks & hot dogs.",
      "poi_long_description": "Casual restaurant with eclectic decor serving smoked burgers, plus cheesesteaks & hot dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f090-75cd-a2bd-f18cb0552c6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f090-75cd-a2bd-f18cb0552c6f",
        "storage_key": "property/6767906449167602/01a01014-f090-75cd-a2bd-f18cb0552c6f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kcsmokeburgers.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3581502734046957737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kc-smoke-burger",
      "poi_latitude": "39.0575007",
      "poi_longitude": "-94.6043973",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-931-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk8JHtyzuwIcRqZD10MINtDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a0e23de8-de63-4450-9218-514ad5565c65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Friends Sushi & Bento Place",
      "poi_type": "Restaurants",
      "poi_address": "1808 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "Welcoming outfit offers a range of sushi & hot Japanese cooking, plus lunch specials.",
      "poi_long_description": "Welcoming outfit offers a range of sushi & hot Japanese cooking, plus lunch specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f71d-73af-b223-9efeec1ff443.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f71d-73af-b223-9efeec1ff443",
        "storage_key": "property/6767906449167602/01a01014-f71d-73af-b223-9efeec1ff443.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://friendssushi.menufy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8536375522138180246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friends-sushi--bento-place",
      "poi_latitude": "39.0574814",
      "poi_longitude": "-94.6066648",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-753-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_0sYSzuwIcRlspiSk9Md3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_b16b0376-3e1a-46fa-aa3c-82cb949088f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Cupini's",
      "poi_type": "Restaurants",
      "poi_address": "1809 Westport Rd Ste 200, Kansas City, MO 64111, USA",
      "poi_short_description": "Cozy counter serves up Italian staples including pasta, pizza & panini in a laid-back setting.",
      "poi_long_description": "Cozy counter serves up Italian staples including pasta, pizza & panini in a laid-back setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f135-775b-883f-5b58545dbf40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f135-775b-883f-5b58545dbf40",
        "storage_key": "property/6767906449167602/01a01014-f135-775b-883f-5b58545dbf40.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://cupinis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14730648302848338824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cupinis",
      "poi_latitude": "39.0500063",
      "poi_longitude": "-94.6069918",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-753-7662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_y8DsDPuwIcRiGt8ypXGbcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1dd0b659-6848-4e75-8566-1c3a2655b660",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Meshuggah Bagels",
      "poi_type": "Restaurants",
      "poi_address": "1208 W 39th St, Kansas City, MO 64111, USA",
      "poi_short_description": "New York style bagel shop offering a variety of flavors and schmears, plus breakfast, and lunch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f0e7-734e-bd25-1086f5e3cc0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f0e7-734e-bd25-1086f5e3cc0b",
        "storage_key": "property/6767906449167602/01a01014-f0e7-734e-bd25-1086f5e3cc0b.webp",
        "width": 1280,
        "height": 967
      },
      "poi_business_url": "http://www.meshuggahbagels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13675545978663753829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meshuggah-bagels",
      "poi_latitude": "39.0573253",
      "poi_longitude": "-94.6010041",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-330-6016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXspoNPvwIcRZVjGh5xMyb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_aba9dd4e-9719-4de9-b099-bb426fe898f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Café Corazón",
      "poi_type": "Restaurants",
      "poi_address": "1721 Westport Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Cozy coffeehouse pouring Latin American coffees and teas, with empanadas, tamales, and alfajores.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f1b2-7024-b8f0-dad3d966e98a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f1b2-7024-b8f0-dad3d966e98a",
        "storage_key": "property/6767906449167602/01a01014-f1b2-7024-b8f0-dad3d966e98a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cafecorazonkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5579751663422091656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-corazn",
      "poi_latitude": "39.0500183",
      "poi_longitude": "-94.606379",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-205-8010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-c00f-753a-9493-47cfa49e9240.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b8-c00f-753a-9493-47cfa49e9240",
        "storage_key": "property/6767906449167602/019ff6b8-c00f-753a-9493-47cfa49e9240.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJZWbQAyzvwIcRiDErOZNCb00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_e3e553ac-a032-46ec-9035-5154b865322d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Donutology",
      "poi_type": "Restaurants",
      "poi_address": "1009 Westport Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Customizable donuts & other sweet treats, plus coffee & smoothies, served in a bright setting.",
      "poi_long_description": "Customizable donuts & other sweet treats, plus coffee & smoothies, served in a bright setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f0e2-72de-95f8-1d2875fb01b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f0e2-72de-95f8-1d2875fb01b8",
        "storage_key": "property/6767906449167602/01a01014-f0e2-72de-95f8-1d2875fb01b8.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://donutology.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10490428042088385704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donutology",
      "poi_latitude": "39.0495735",
      "poi_longitude": "-94.598647",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-298-5222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWd2UH8zvwIcRqIx5Prl8lZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_be82415d-4829-479c-8234-c2a9789854fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Blue Sushi Sake Grill",
      "poi_type": "Restaurants",
      "poi_address": "4705 Rainbow Blvd, Westwood, KS 66205, USA",
      "poi_short_description": "Modern, clubby restaurant featuring sushi & Japanese tapas, plus fancy mixed drinks.",
      "poi_long_description": "Modern, clubby restaurant featuring sushi & Japanese tapas, plus fancy mixed drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f4d5-7122-b08f-6252b02f1dad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f4d5-7122-b08f-6252b02f1dad",
        "storage_key": "property/6767906449167602/01a01014-f4d5-7122-b08f-6252b02f1dad.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://bluesushisakegrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2114597261401729657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-sushi-sake-grill",
      "poi_latitude": "39.0438644",
      "poi_longitude": "-94.6115502",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-236-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcxEotjfuwIcReSrdcAGPWB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_219aff08-f5b8-41c3-8461-98189f555465",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Lulu's Thai Noodle Shop",
      "poi_type": "Restaurants",
      "poi_address": "2701 W 47th Ave, Westwood, KS 66205, USA",
      "poi_short_description": "Relaxed eatery featuring Thai specialties like curries and noodle dishes, plus some gluten-free options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-f96e-71c4-b8c5-adf9e9f60956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f96e-71c4-b8c5-adf9e9f60956",
        "storage_key": "property/6767906449167602/01a01014-f96e-71c4-b8c5-adf9e9f60956.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.lulusnoodles.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1819123937442580444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lulus-thai-noodle-shop",
      "poi_latitude": "39.0438541",
      "poi_longitude": "-94.616867",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-677-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz6vz9DjuwIcR3MesPZXTPhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_df6957ce-6156-4d67-a63d-7ab2d2358ee2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 Central Ave, Kansas City, KS 66102, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-fc3f-766d-be15-65bc59ab77b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-fc3f-766d-be15-65bc59ab77b7",
        "storage_key": "property/6767906449167602/01a01014-fc3f-766d-be15-65bc59ab77b7.webp",
        "width": 1280,
        "height": 746
      },
      "poi_business_url": "https://www.7-eleven.com/locations/ks/kansas-city/2500-central-ave-13245?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6975709962269424972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "39.1091241",
      "poi_longitude": "-94.658234",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-321-5142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-36a2-74d8-89fc-e9e527fa9587.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01015-36a2-74d8-89fc-e9e527fa9587",
        "storage_key": "property/6767906449167602/01a01015-36a2-74d8-89fc-e9e527fa9587.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQwXhYs7zwIcRTP04dUCzzmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_e6548ef5-d4a6-4e54-8d4a-6b867b3fb479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 Rainbow Blvd, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-572d-71ea-9071-66848d060915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-572d-71ea-9071-66848d060915",
        "storage_key": "property/6767906449167602/019fc980-572d-71ea-9071-66848d060915.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/kansas-city-ks-pharmacies/4300-rainbow-blvd-kansas-city-ks-66103/storeid=8919?WT.mc_id=LS_GOOGLE_RX_8919",
      "poi_directions_map_url": "https://maps.google.com/?cid=9813976029694964448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.0499895",
      "poi_longitude": "-94.6125189",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-403-0581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-c021-778d-a5b8-317a11575702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b8-c021-778d-a5b8-317a11575702",
        "storage_key": "property/6767906449167602/019ff6b8-c021-778d-a5b8-317a11575702.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHUzp8zDuwIcR4LIqzDM_Mog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_b3ea257c-ff75-40f6-901e-62723404657b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Pharmacy, Cambridge Tower A",
      "poi_type": "Health and Wellness",
      "poi_address": "3825 Cambridge St Level 1, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-9325-704f-be42-09eba90f6732.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-9325-704f-be42-09eba90f6732",
        "storage_key": "property/6767906449167602/019ff6b8-9325-704f-be42-09eba90f6732.webp",
        "width": 1176,
        "height": 1280
      },
      "poi_business_url": "https://www.kansashealthsystem.com/pharmacy-services?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=8729388179907787493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pharmacy-cambridge-tower-a",
      "poi_latitude": "39.0582205",
      "poi_longitude": "-94.6077561",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-574-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-c021-778d-a5b8-317a11575702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b8-c021-778d-a5b8-317a11575702",
        "storage_key": "property/6767906449167602/019ff6b8-c021-778d-a5b8-317a11575702.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_UKK-CvuwIcR5brloUwEJXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_08c94efe-d94b-476e-b753-e5e489df93e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 Metropolitan Ave, Kansas City, KS 66106, USA",
      "poi_short_description": "Neighborhood chain supplying its typical selection of groceries, electronics, and other merchandise, plus a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-633f-711d-a7d0-955d2022dd5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-633f-711d-a7d0-955d2022dd5b",
        "storage_key": "property/6767906449167602/019fc980-633f-711d-a7d0-955d2022dd5b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/6172-kansas-city-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3606846096736786939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "39.0747548",
      "poi_longitude": "-94.655947",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-748-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57b5-73e9-b3cf-1b8d9e7c2fbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57b5-73e9-b3cf-1b8d9e7c2fbc",
        "storage_key": "property/6767906449167602/019fc97c-57b5-73e9-b3cf-1b8d9e7c2fbc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOU0ARhvywIcR-xmAQ2oXDjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d8f29563-1877-4936-ac83-999ead5c4d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "520 County Line Rd, Kansas City, KS 66103, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-871f-7687-b072-3771ab40ac54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-871f-7687-b072-3771ab40ac54",
        "storage_key": "property/6767906449167602/019ff6b8-871f-7687-b072-3771ab40ac54.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dollartree.com/ks/kansas-city/520-county-line-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2123688549872954686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "39.0444246",
      "poi_longitude": "-94.6223553",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-730-2078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-44ed653c866a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-44ed653c866a",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-44ed653c866a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaZoNrj_uwIcRPu29_HvbeB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_ca203883-9b58-43c1-b9c5-64d19139d044",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "4805 State Ave, Kansas City, KS 66102, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-fc42-728f-aaa0-acfc33d557c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-fc42-728f-aaa0-acfc33d557c4",
        "storage_key": "property/6767906449167602/01a01014-fc42-728f-aaa0-acfc33d557c4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/kansas-city/4805-state-ave/f334",
      "poi_directions_map_url": "https://maps.google.com/?cid=9473382264884744951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.115964",
      "poi_longitude": "-94.689841",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57b5-73e9-b3cf-1b8d9e7c2fbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57b5-73e9-b3cf-1b8d9e7c2fbc",
        "storage_key": "property/6767906449167602/019fc97c-57b5-73e9-b3cf-1b8d9e7c2fbc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Ry0GgnzwIcR99LwT_o2eIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_27f193bc-bb04-45d6-8383-bacdbdfedace",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "3101 Southwest Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01014-fbdf-73fa-b929-11eab5986aa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-fbdf-73fa-b929-11eab5986aa3",
        "storage_key": "property/6767906449167602/01a01014-fbdf-73fa-b929-11eab5986aa3.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/mo/kansas-city/3101-southwest-blvd?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQyMDEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6441237271209954463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "39.0717013",
      "poi_longitude": "-94.6070743",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-931-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-36b0-77b6-97be-4a14d02f82b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01015-36b0-77b6-97be-4a14d02f82b8",
        "storage_key": "property/6767906449167602/01a01015-36b0-77b6-97be-4a14d02f82b8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJq8M0SdLxwIcRn8x5yCvfY1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_e791b446-c3f9-4178-99dd-1a62944b7ffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Frank Rushton Elementary",
      "poi_type": "Education",
      "poi_address": "2605 W 43rd Ave, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-67ec-766a-8b52-4d3fee601d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-67ec-766a-8b52-4d3fee601d0c",
        "storage_key": "property/6767906449167602/019fc980-67ec-766a-8b52-4d3fee601d0c.webp",
        "width": 1280,
        "height": 665
      },
      "poi_business_url": "https://frankrushton.kckschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13906864216317242448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-rushton-elementary",
      "poi_latitude": "39.0494851",
      "poi_longitude": "-94.6156757",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-627-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqVJ7szHuwIcRUCwusVIb_8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_28d2b85b-0237-4fc5-87b0-fa0a4b726256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Rosedale Middle School",
      "poi_type": "Education",
      "poi_address": "3600 Springfield St, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rosedale.kckschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9029482663399016616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosedale-middle-school",
      "poi_latitude": "39.062073",
      "poi_longitude": "-94.6155788",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-627-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_WR6jyfuwIcRqEhyYaQqT30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_66e93e27-6fca-4f6c-a4ca-d521c17424f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "T.A. Edison Elementary School",
      "poi_type": "Education",
      "poi_address": "1000 Locust St, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://taedison.kckschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=723558957284196295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ta-edison-elementary-school",
      "poi_latitude": "39.0482638",
      "poi_longitude": "-94.6355918",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-627-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ64rvQw7uwIcRx__5vgmZCgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6432eb1e-25ed-4fe3-bacc-d008a54a1342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Holy Name of Jesus Catholic School",
      "poi_type": "Education",
      "poi_address": "1007 Southwest Blvd, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.holynamecatholicschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11494979345841683045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-name-of-jesus-catholic-school",
      "poi_latitude": "39.0611783",
      "poi_longitude": "-94.6207548",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-722-1032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV91d4SDuwIcRZXpY4c9ehp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_278e5784-5421-49a1-a363-7025743f4236",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Our Lady's Montessori School",
      "poi_type": "Education",
      "poi_address": "5809 Michigan Ave, Kansas City, MO 64130, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olmskc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15255511760622209944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "our-ladys-montessori-school",
      "poi_latitude": "39.020875",
      "poi_longitude": "-94.5633291",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-543-5909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOftc3xXuwIcRmEuufh53ttM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_26b4a5be-6f9a-457f-90e8-95b5c23ffdb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "J.C. Harmon High School",
      "poi_type": "Education",
      "poi_address": "2400 Steele Rd, Kansas City, KS 66106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-8c1d-74f4-ad03-e6c5753060b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-8c1d-74f4-ad03-e6c5753060b1",
        "storage_key": "property/6767906449167602/019ff6b8-8c1d-74f4-ad03-e6c5753060b1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://harmon.kckschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3328122852953224634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jc-harmon-high-school",
      "poi_latitude": "39.0634458",
      "poi_longitude": "-94.6568295",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-627-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmRJHYQjywIcRuvUiAxreLy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e74373d1-42eb-415a-a0ea-13690a67021b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Westwood View Elementary School",
      "poi_type": "Education",
      "poi_address": "4935 Belinder Ave, Westwood, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://westwoodview.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5939654359948644934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-view-elementary-school",
      "poi_latitude": "39.0378",
      "poi_longitude": "-94.615947",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-993-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3aOvCQDvwIcRRtJWtSvkbVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9a66addf-7ed5-4abd-a53b-b4d64cf92f96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "KU Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Rainbow Blvd, Kansas City, KS 66160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-2a0d-71fb-ac52-fec4d68782ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-2a0d-71fb-ac52-fec4d68782ae",
        "storage_key": "property/6767906449167602/019fc97c-2a0d-71fb-ac52-fec4d68782ae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kumc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9948285583475587924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ku-medical-center",
      "poi_latitude": "39.0582747",
      "poi_longitude": "-94.6105991",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-588-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57ad-745b-b9cf-3ede99f14bd2",
        "storage_key": "property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbsoKb3vwIcRVLszpwdpD4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_a1b36690-3f3d-4c28-8c29-12bfdd24166b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kansas City Kansas Community College",
      "poi_type": "Education",
      "poi_address": "7250 State Ave, Kansas City, KS 66112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-72e4-7476-8ac4-c0b88e2b5cc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-72e4-7476-8ac4-c0b88e2b5cc3",
        "storage_key": "property/6767906449167602/019fc980-72e4-7476-8ac4-c0b88e2b5cc3.webp",
        "width": 1280,
        "height": 416
      },
      "poi_business_url": "https://www.kckcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10767688527998207620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-kansas-community-college",
      "poi_latitude": "39.122216",
      "poi_longitude": "-94.7485212",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-334-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf8Vhyb-MwIcRhMZho6qDbpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_479bd2ae-edf7-4db5-a88d-daccf52af20d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kansas City Art Institute",
      "poi_type": "Education",
      "poi_address": "4415 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-0025-7459-9eb2-89a61aafea50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-0025-7459-9eb2-89a61aafea50",
        "storage_key": "property/6767906449167602/01a01015-0025-7459-9eb2-89a61aafea50.webp",
        "width": 705,
        "height": 670
      },
      "poi_business_url": "http://www.kcai.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3056374416396262313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-art-institute",
      "poi_latitude": "39.0466734",
      "poi_longitude": "-94.5834059",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-472-4852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJffVj1cHvwIcRqRvknVZsaio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d822505e-2a8e-4e61-94bb-2363fc79574a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Boulevard Drive-In Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1051 Merriam Ln, Kansas City, KS 66103, USA",
      "poi_short_description": "Double-feature drive-in movies at a classic, family-friendly venue with a snack bar & a playground.",
      "poi_long_description": "Double-feature drive-in movies at a classic, family-friendly venue with a snack bar & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-8dcc-777c-a12e-9c2613b86316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-8dcc-777c-a12e-9c2613b86316",
        "storage_key": "property/6767906449167602/019ff6b8-8dcc-777c-a12e-9c2613b86316.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://boulevarddrivein.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=534227299373071463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boulevard-drive-in-theatre",
      "poi_latitude": "39.0555472",
      "poi_longitude": "-94.6370202",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-262-0392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-c010-7188-8575-8601192390d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b8-c010-7188-8575-8601192390d1",
        "storage_key": "property/6767906449167602/019ff6b8-c010-7188-8575-8601192390d1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfXi5ATuwIcRZ7xy-OX0aQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_1290b6bf-a33d-41b5-8084-147af068bea9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Arabia Steamboat Museum",
      "poi_type": "Entertainment",
      "poi_address": "400 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "Big collection of everyday objects pulled from a steamboat that sunk on the Missouri River in 1856.",
      "poi_long_description": "Big collection of everyday objects pulled from a steamboat that sunk on the Missouri River in 1856.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-0331-70ce-b423-dd511af9e77a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-0331-70ce-b423-dd511af9e77a",
        "storage_key": "property/6767906449167602/01a01015-0331-70ce-b423-dd511af9e77a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.1856.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11599582778406541076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arabia-steamboat-museum",
      "poi_latitude": "39.1094732",
      "poi_longitude": "-94.5813811",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-471-1856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5758-76ae-a2e4-ee9d7bef3ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5758-76ae-a2e4-ee9d7bef3ac8",
        "storage_key": "property/6767906449167602/019fc97c-5758-76ae-a2e4-ee9d7bef3ac8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJkQe4HYvwwIcRFBepaRT_-aA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_890085bc-edf8-432f-be54-35f378a2e81c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "National WWI Museum and Memorial",
      "poi_type": "Entertainment",
      "poi_address": "2 Memorial Dr, Kansas City, MO 64108, USA",
      "poi_short_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_long_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-0e39-7737-a62b-69ccf1b69df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-0e39-7737-a62b-69ccf1b69df2",
        "storage_key": "property/6767906449167602/019fc97c-0e39-7737-a62b-69ccf1b69df2.webp",
        "width": 1280,
        "height": 1071
      },
      "poi_business_url": "https://www.theworldwar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469991631701161311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-wwi-museum-and-memorial",
      "poi_latitude": "39.080663",
      "poi_longitude": "-94.5860835",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-888-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5758-76ae-a2e4-ee9d7bef3ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5758-76ae-a2e4-ee9d7bef3ac8",
        "storage_key": "property/6767906449167602/019fc97c-5758-76ae-a2e4-ee9d7bef3ac8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzAyJjzwwIcRXzXcqOrhTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ca2c5a0d-0dbd-4d74-9628-0e7c4297580c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Negro Leagues Baseball Museum",
      "poi_type": "Entertainment",
      "poi_address": "1616 E 18th St, Kansas City, MO 64108, USA",
      "poi_short_description": "Exhibits on segregated league's 1920 founding to Jackie Robinson's 1947 Brooklyn Dodgers debut.",
      "poi_long_description": "Exhibits on segregated league's 1920 founding to Jackie Robinson's 1947 Brooklyn Dodgers debut.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-95e4-7272-830a-d0a98fc318eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-95e4-7272-830a-d0a98fc318eb",
        "storage_key": "property/6767906449167602/019fc981-95e4-7272-830a-d0a98fc318eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlbm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11911160217324044073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "negro-leagues-baseball-museum",
      "poi_latitude": "39.0913923",
      "poi_longitude": "-94.5626542",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-221-1920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5758-76ae-a2e4-ee9d7bef3ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5758-76ae-a2e4-ee9d7bef3ac8",
        "storage_key": "property/6767906449167602/019fc97c-5758-76ae-a2e4-ee9d7bef3ac8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YLPAHbwwIcRKT9dEBzxTKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ae692611-cba5-41d4-92a3-15033f92a31e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Science City at Union Station",
      "poi_type": "Entertainment",
      "poi_address": "30 W Pershing Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-friendly museum with interactive science displays, including a test kitchen & planetarium.",
      "poi_long_description": "Family-friendly museum with interactive science displays, including a test kitchen & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-8e2a-70ff-b7ba-2b542188519f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-8e2a-70ff-b7ba-2b542188519f",
        "storage_key": "property/6767906449167602/019ff6b8-8e2a-70ff-b7ba-2b542188519f.webp",
        "width": 720,
        "height": 541
      },
      "poi_business_url": "http://www.unionstation.org/sciencecity",
      "poi_directions_map_url": "https://maps.google.com/?cid=12787524424421866697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "science-city-at-union-station",
      "poi_latitude": "39.085408",
      "poi_longitude": "-94.5861467",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-460-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5758-76ae-a2e4-ee9d7bef3ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5758-76ae-a2e4-ee9d7bef3ac8",
        "storage_key": "property/6767906449167602/019fc97c-5758-76ae-a2e4-ee9d7bef3ac8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_t4g0DwwIcRyfxLerZpdrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e1c60d30-5141-47ed-9050-194ea1564fdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "LEGOLAND Discovery Center Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd East Retail Suite 200; Crown Center Shops, Kansas City, MO 64108, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & a 4-D theater, plus a gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & a 4-D theater, plus a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-d28a-72a8-a174-4b98eeb9acc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-d28a-72a8-a174-4b98eeb9acc1",
        "storage_key": "property/6767906449167602/019fc980-d28a-72a8-a174-4b98eeb9acc1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7206990507281059484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-kansas-city",
      "poi_latitude": "39.08208190000001",
      "poi_longitude": "-94.5813858",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-556-3958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qq6ljwwIcRnI4Znq5fBGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_89d524a7-6e22-4bbb-b3bb-27fc6c7e30ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "SEA LIFE Kansas City Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd Ste 100, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_long_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-c40d-7410-83ed-f950dd365c3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-c40d-7410-83ed-f950dd365c3e",
        "storage_key": "property/6767906449167602/019fc980-c40d-7410-83ed-f950dd365c3e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.visitsealife.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590252280065768693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-kansas-city-aquarium",
      "poi_latitude": "39.0820805",
      "poi_longitude": "-94.5812573",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-471-4386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-36b7-766a-9e14-feeb00ca2cc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01015-36b7-766a-9e14-feeb00ca2cc7",
        "storage_key": "property/6767906449167602/01a01015-36b7-766a-9e14-feeb00ca2cc7.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJtyRwuxXwwIcR9TwjjtSQlE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_96252f17-27a6-43fe-9b15-b06b761b69ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Grinders Pizza",
      "poi_type": "Restaurants",
      "poi_address": "417 E 18th St, Kansas City, MO 64108, USA",
      "poi_short_description": "Hopping haunt with a laid-back vibe serving American grub such as thin-crust pies & grinders.",
      "poi_long_description": "Hopping haunt with a laid-back vibe serving American grub such as thin-crust pies & grinders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-077e-766c-8e4c-83495d8bb434.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-077e-766c-8e4c-83495d8bb434",
        "storage_key": "property/6767906449167602/01a01015-077e-766c-8e4c-83495d8bb434.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "http://www.grinderspizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6819665727325439585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grinders-pizza",
      "poi_latitude": "39.0914193",
      "poi_longitude": "-94.5781167",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-472-5454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5759-76c1-b49f-402e780ac2ca",
        "storage_key": "property/6767906449167602/019fc97c-5759-76c1-b49f-402e780ac2ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29SyTWnwwIcRYYYjzNhRpF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5fdb9072-b858-4652-af21-b2915ed71079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "The Rino",
      "poi_type": "Entertainment",
      "poi_address": "314 Armour Rd, North Kansas City, MO 64116, USA",
      "poi_short_description": "Intimate setting for live music, comedy and other shows, with a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-0401-75dc-8662-2a59868a6a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-0401-75dc-8662-2a59868a6a0a",
        "storage_key": "property/6767906449167602/01a01015-0401-75dc-8662-2a59868a6a0a.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "http://www.therinokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4762505408712973249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rino",
      "poi_latitude": "39.1423104",
      "poi_longitude": "-94.5765184",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4SsNZ7HwwIcRwZs2t2_RF0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_7b868d5b-8dab-4651-9f7e-0b69bb4f4f39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kauffman Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1601 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_long_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-d34c-711d-ab23-1f40770c1582.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-d34c-711d-ab23-1f40770c1582",
        "storage_key": "property/6767906449167602/019fc980-d34c-711d-ab23-1f40770c1582.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kauffmancenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371724031435486048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kauffman-center-for-the-performing-arts",
      "poi_latitude": "39.0941068",
      "poi_longitude": "-94.5876247",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-994-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99d4bkPwwIcRYDOIbD_pbFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_3979998a-878f-4444-9720-472d99c62518",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "University of Kansas Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Cambridge St, Kansas City, KS 66160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-ae32-751e-a6ae-670e4cb3c25a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-ae32-751e-a6ae-670e4cb3c25a",
        "storage_key": "property/6767906449167602/019fc980-ae32-751e-a6ae-670e4cb3c25a.webp",
        "width": 464,
        "height": 350
      },
      "poi_business_url": "https://www.kansashealthsystem.com/locations/main-campus-main-hospital-kansas-city-ks?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=13611292166222622032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-kansas-hospital",
      "poi_latitude": "39.0557754",
      "poi_longitude": "-94.6093162",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-588-1227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57ad-745b-b9cf-3ede99f14bd2",
        "storage_key": "property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7b8ZkC7uwIcRUK3BBRwG5bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_78cecfd2-c7a2-42a6-88fe-36e1e9505ec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Pharmacy, The University of Kansas Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Cambridge St Level G, Suite BH.G400, Kansas City, KS 66160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-ae32-751e-a6ae-670e4cb3c25a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-ae32-751e-a6ae-670e4cb3c25a",
        "storage_key": "property/6767906449167602/019fc980-ae32-751e-a6ae-670e4cb3c25a.webp",
        "width": 464,
        "height": 350
      },
      "poi_business_url": "https://www.kansashealthsystem.com/pharmacy-services?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=9507310262541791913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pharmacy-the-university-of-kansas-hospital",
      "poi_latitude": "39.056753",
      "poi_longitude": "-94.6088515",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-588-2361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-c021-778d-a5b8-317a11575702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b8-c021-778d-a5b8-317a11575702",
        "storage_key": "property/6767906449167602/019ff6b8-c021-778d-a5b8-317a11575702.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0eNq3wzvwIcRqbI62E_A8IM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ff506864-fc14-484a-b5d4-558d14f5015d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kirmayer Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2141 Olathe Blvd, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-ffe1-7129-84c6-87ec48f9cc68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-ffe1-7129-84c6-87ec48f9cc68",
        "storage_key": "property/6767906449167602/019fc980-ffe1-7129-84c6-87ec48f9cc68.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kumc.edu/academic-and-student-affairs/departments/kirmayer-fitness-center.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16228654795478727519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kirmayer-fitness-center",
      "poi_latitude": "39.0538513",
      "poi_longitude": "-94.6109436",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-588-1532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTRs6dgDvwIcRX_vyqo3DN-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_973d06cf-9e97-4f92-bf43-c081992c09c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Auto Accident Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4318 Rainbow Blvd, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-ff2a-76e8-b88a-46ab04286f40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc980-ff2a-76e8-b88a-46ab04286f40",
        "storage_key": "property/6767906449167602/019fc980-ff2a-76e8-b88a-46ab04286f40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.autoaccidenturgentcare.com/?utm_source=google&utm_medium=gbp&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5023452687686164643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "auto-accident-urgent-care",
      "poi_latitude": "39.0493895",
      "poi_longitude": "-94.6122998",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-258-8883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4Th6DDuwIcRo-CDo5rjtkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_6863ec3a-1803-43df-8d5f-296f3939626e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4214 Kansas Ave, Kansas City, KS 66106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-077d-744a-abcf-eda804464158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-077d-744a-abcf-eda804464158",
        "storage_key": "property/6767906449167602/01a01015-077d-744a-abcf-eda804464158.webp",
        "width": 1280,
        "height": 709
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14187366899243697964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "39.0910085",
      "poi_longitude": "-94.6776009",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-321-7557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTph-1rywIcRLEeO5wan48Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_d6cb6761-16da-4add-8064-5504e01eb517",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Vibrant Health Family Health Care",
      "poi_type": "Health and Wellness",
      "poi_address": "340 Southwest Blvd, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-92b9-76ba-8c40-6f4e969243ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-92b9-76ba-8c40-6f4e969243ca",
        "storage_key": "property/6767906449167602/019ff6b8-92b9-76ba-8c40-6f4e969243ca.webp",
        "width": 837,
        "height": 861
      },
      "poi_business_url": "https://vibranthealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2873929208026120122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vibrant-health-family-health-care",
      "poi_latitude": "39.0682721",
      "poi_longitude": "-94.6134431",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-342-2552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWlkMcHxwIcRuj8EUmM_4ic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8eb397cd-6c6c-4419-b36c-b004b1d71f90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Turner Recreation Commission",
      "poi_type": "Health and Wellness",
      "poi_address": "831 S 55th St, Kansas City, KS 66106, USA",
      "poi_short_description": "Small rec center offering sports, dance and karate classes as well as camps and childcare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-0fb5-77bc-9e38-ba7b36fdd868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-0fb5-77bc-9e38-ba7b36fdd868",
        "storage_key": "property/6767906449167602/01a01015-0fb5-77bc-9e38-ba7b36fdd868.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.turnerrecreation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1984797299772585510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "turner-recreation-commission",
      "poi_latitude": "39.0826161",
      "poi_longitude": "-94.7041908",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-287-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5x8x_urywIcRJnYZ1KBqixs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_2a4fb80e-68da-4537-85ac-eaa75d8ece0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Rosedale Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4100 Mission Rd, Kansas City, KS 66103, USA",
      "poi_short_description": "Outdoor space with softball fields & a playground, plus picnic area, skate park & disc golf courses.",
      "poi_long_description": "Outdoor space with softball fields & a playground, plus picnic area, skate park & disc golf courses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-aee3-708e-88bc-5c647856a863.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-aee3-708e-88bc-5c647856a863",
        "storage_key": "property/6767906449167602/019ff6b8-aee3-708e-88bc-5c647856a863.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "http://www.wycokck.org/Home.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11938821695662986912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosedale-park",
      "poi_latitude": "39.05255500000001",
      "poi_longitude": "-94.6215018",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-573-8327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57aa-7553-965f-614326ea3f68",
        "storage_key": "property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Zu1YhjuwIcRoBa43hM3r6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bbd6cfa6-8c11-4a00-9399-c0ad9c029bee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Rosedale Memorial Arch",
      "poi_type": "Entertainment",
      "poi_address": "3602 Springfield St, Kansas City, KS 66103, USA",
      "poi_short_description": "This arched monument for WWI veterans resembles the Arc de Triomphe & is illuminated at night.",
      "poi_long_description": "This arched monument for WWI veterans resembles the Arc de Triomphe & is illuminated at night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-5ed9-77e9-bead-173ec033bfa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-5ed9-77e9-bead-173ec033bfa7",
        "storage_key": "property/6767906449167602/019fc981-5ed9-77e9-bead-173ec033bfa7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wycokck.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2272886151660334086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosedale-memorial-arch",
      "poi_latitude": "39.0638128",
      "poi_longitude": "-94.6150278",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-573-8327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc3hxDtjxwIcRBmyepOnpih8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c27d5f00-e7b4-4b11-a2c4-886a935d8fa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Fisher Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Fisher Park, 3818 Springfield St, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-f91e-70a9-a2a0-f0969138e6cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-f91e-70a9-a2a0-f0969138e6cf",
        "storage_key": "property/6767906449167602/019fc981-f91e-70a9-a2a0-f0969138e6cf.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1193908184279240859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fisher-park",
      "poi_latitude": "39.0577005",
      "poi_longitude": "-94.615872",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57aa-7553-965f-614326ea3f68",
        "storage_key": "property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIyQl2iXuwIcRm1BlAiudkRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_39131ae7-22e1-4cae-998a-716ede9ebbad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Rozarks Nature Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Park Dr, Kansas City, KS 66103, USA",
      "poi_short_description": "Trails for walking, hiking and mountain biking, plus a memorial, within a city area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-3447-72c5-9e97-3f298e900c22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-3447-72c5-9e97-3f298e900c22",
        "storage_key": "property/6767906449167602/019fc981-3447-72c5-9e97-3f298e900c22.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9233998615153784631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rozarks-nature-trail",
      "poi_latitude": "39.0638834",
      "poi_longitude": "-94.615053",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-677-5097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-36a4-7668-a780-8e2dce98ff4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01015-36a4-7668-a780-8e2dce98ff4d",
        "storage_key": "property/6767906449167602/01a01015-36a4-7668-a780-8e2dce98ff4d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJITJsEdjxwIcRN7ewENHAJYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_d0cf2e97-1416-41a5-9f90-b113dc302f9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Roanoke Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1209 Valentine Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Pleasant city park dotted with basketball courts, baseball fields and volleyball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-9dc8-7403-b7d7-f0bae6aaf921.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-9dc8-7403-b7d7-f0bae6aaf921",
        "storage_key": "property/6767906449167602/019ff6b8-9dc8-7403-b7d7-f0bae6aaf921.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://www.roanokeparkkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15292107770354465273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roanoke-park",
      "poi_latitude": "39.0604817",
      "poi_longitude": "-94.6003493",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-830-1791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57aa-7553-965f-614326ea3f68",
        "storage_key": "property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWygGnTvwIcR-fn3_v56ONQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_2341ec34-4584-4e37-8088-72ab6dbaf0a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Berkley Riverfront",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "950 Riverfront Dr, Kansas City, MO 64120, USA",
      "poi_short_description": "Downtown green space along the Missouri River features broad biking & walking paths & open fields.",
      "poi_long_description": "Downtown green space along the Missouri River features broad biking & walking paths & open fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-1273-766d-b1f1-539d7940c7e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-1273-766d-b1f1-539d7940c7e6",
        "storage_key": "property/6767906449167602/01a01015-1273-766d-b1f1-539d7940c7e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://berkleyriverfront.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3315902073752463479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "berkley-riverfront",
      "poi_latitude": "39.1168217",
      "poi_longitude": "-94.5726106",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-559-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57aa-7553-965f-614326ea3f68",
        "storage_key": "property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2yvAJDwwIcRdyj_H15zBC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_281344e0-f68c-466a-bbcf-ad553be7742c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kaw Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1403 Fairfax Trafficway, Kansas City, KS 66115, USA",
      "poi_short_description": "Park with skyline views as well as water activities, theater events & Lewis & Clark heritage trail.",
      "poi_long_description": "Park with skyline views as well as water activities, theater events & Lewis & Clark heritage trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-3933-722c-9408-acd568595ee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-3933-722c-9408-acd568595ee2",
        "storage_key": "property/6767906449167602/019fc97c-3933-722c-9408-acd568595ee2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kawpointpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1360269482962527033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaw-point-park",
      "poi_latitude": "39.1165937",
      "poi_longitude": "-94.6105429",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57aa-7553-965f-614326ea3f68",
        "storage_key": "property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4tf2xrxwIcROSPJQuOl4BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_304c3426-0e6a-4e53-afe4-096817dccbb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Armourdale Levee Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2018 Kansas Ave, Kansas City, KS 66105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-171b-701d-9e10-d938e292d9dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-171b-701d-9e10-d938e292d9dd",
        "storage_key": "property/6767906449167602/01a01015-171b-701d-9e10-d938e292d9dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14450342117717029886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armourdale-levee-trail",
      "poi_latitude": "39.087662",
      "poi_longitude": "-94.6502806",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-321-6066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-36a4-7668-a780-8e2dce98ff4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01015-36a4-7668-a780-8e2dce98ff4d",
        "storage_key": "property/6767906449167602/01a01015-36a4-7668-a780-8e2dce98ff4d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7RBZJbzwIcR_rNjSZjticg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_61c76f8e-2250-481e-a1c1-6a6ed618422b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Jersey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Kansas City, KS 66104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-177e-70cc-82b8-f8f4f0f70643.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-177e-70cc-82b8-f8f4f0f70643",
        "storage_key": "property/6767906449167602/01a01015-177e-70cc-82b8-f8f4f0f70643.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10536007670597561533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jersey-creek-park",
      "poi_latitude": "39.1244535",
      "poi_longitude": "-94.6288938",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57aa-7553-965f-614326ea3f68",
        "storage_key": "property/6767906449167602/019fc97c-57aa-7553-965f-614326ea3f68.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____D2rxwIcRvSzCfCdrN5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e9b79d1f-9d8b-43aa-aabe-c42e5812b174",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "RideKC - 39th St & Troost Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3829 Troost Ave, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ridekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7289192013737135469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridekc---39th-st--troost-transit-center",
      "poi_latitude": "39.0563082",
      "poi_longitude": "-94.5718268",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-842-9070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUypIaHvwIcRbY1qRoRpKGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_27ca303c-644c-40e0-8c91-6f66b5f5a48a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kansas City 47Th St Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, KS 66102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15986244376617175594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-47th-st-transit-center",
      "poi_latitude": "39.11365",
      "poi_longitude": "-94.68587",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-c024-70e8-9b69-13d2b9bf46d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b8-c024-70e8-9b69-13d2b9bf46d9",
        "storage_key": "property/6767906449167602/019ff6b8-c024-70e8-9b69-13d2b9bf46d9.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJESfn8qfzwIcRKkra0I-M2t0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_600d7d4c-cab4-4843-bd2f-a43c393098e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "East Village Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-b83f-701f-9192-ed6dfba737fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-b83f-701f-9192-ed6dfba737fe",
        "storage_key": "property/6767906449167602/019fc981-b83f-701f-9192-ed6dfba737fe.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "http://ridekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16512695178041122718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-village-transit-center",
      "poi_latitude": "39.0994481",
      "poi_longitude": "-94.5736732",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-221-0660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVzzDLhPxwIcRnl9yw8bgKOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_93ac182c-8d66-4f5c-b43d-39c17884e15f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 Troost Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-9c33-776e-90a2-003d48d73e7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-9c33-776e-90a2-003d48d73e7f",
        "storage_key": "property/6767906449167602/019ff6b8-9c33-776e-90a2-003d48d73e7f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/kansas-city-mo/kansas-city-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16685443334022975407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "39.1000335",
      "poi_longitude": "-94.5693013",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWy-YvXvwwIcRr09ZHE-ajuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_4e9b515c-383b-45e7-9aae-0902ce99d699",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-49bd-7373-95eb-4ece6774651f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-49bd-7373-95eb-4ece6774651f",
        "storage_key": "property/6767906449167602/019fc97c-49bd-7373-95eb-4ece6774651f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5a63-7209-8990-6b2199a35c07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5a63-7209-8990-6b2199a35c07",
        "storage_key": "property/6767906449167602/019fc97c-5a63-7209-8990-6b2199a35c07.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_ac542fab-4277-42cd-94e7-31297c399cfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-cb51-743b-add5-58a8f4f35271.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-cb51-743b-add5-58a8f4f35271",
        "storage_key": "property/6767906449167602/019fc981-cb51-743b-add5-58a8f4f35271.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "24.9",
      "poi_walking_minutes": "9 hours 18 mins",
      "poi_biking_minutes": "2 hours 55 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5a09-765f-a367-6e1abde1a5c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5a09-765f-a367-6e1abde1a5c7",
        "storage_key": "property/6767906449167602/019fc97c-5a09-765f-a367-6e1abde1a5c7.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_699f310c-5dd3-4b8a-8f5c-fb212c8c6c68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "BikeWalkKC",
      "poi_type": "Transportation & Transit",
      "poi_address": "1106 E 30th St Ste G, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-3059-7449-aadf-238916ba9eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-3059-7449-aadf-238916ba9eb1",
        "storage_key": "property/6767906449167602/01a01015-3059-7449-aadf-238916ba9eb1.webp",
        "width": 1280,
        "height": 790
      },
      "poi_business_url": "http://www.bikewalkkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1500022561484279170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bikewalkkc",
      "poi_latitude": "39.0723805",
      "poi_longitude": "-94.5706683",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-205-7056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR25bmPLxwIcRgo1XfJIm0RQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_cd8260f8-ebc8-4b00-8bc6-90258c63b10c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "University Health Truman Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019ff6b8-9f4e-7189-8a76-4ab261ee18b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-9f4e-7189-8a76-4ab261ee18b6",
        "storage_key": "property/6767906449167602/019ff6b8-9f4e-7189-8a76-4ab261ee18b6.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094198644431175220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-truman-medical-center",
      "poi_latitude": "39.0841581",
      "poi_longitude": "-94.5752125",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57ad-745b-b9cf-3ede99f14bd2",
        "storage_key": "property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidv_PG3wwIcRNL7Q-UXN8Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e2cbeea6-8553-4f22-b379-5f05829c654c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-2e9f-714c-bde1-e98eda1f213a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-2e9f-714c-bde1-e98eda1f213a",
        "storage_key": "property/6767906449167602/019fc97c-2e9f-714c-bde1-e98eda1f213a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57ad-745b-b9cf-3ede99f14bd2",
        "storage_key": "property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_04d4ce0b-89e2-4420-b202-0db1d593603f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Unified Government of Wyandotte County and Kansas City, Kansas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 N 7th St Trfy, Kansas City, KS 66101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-da2e-7495-ae0a-e0d521b64c56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc981-da2e-7495-ae0a-e0d521b64c56",
        "storage_key": "property/6767906449167602/019fc981-da2e-7495-ae0a-e0d521b64c56.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "https://www.wycokck.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6145616643868500412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unified-government-of-wyandotte-county-and-kansas-city-kansas",
      "poi_latitude": "39.11322990000001",
      "poi_longitude": "-94.6264122",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-573-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-5ac3-709b-8fae-7e0d67f6c5e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-5ac3-709b-8fae-7e0d67f6c5e1",
        "storage_key": "property/6767906449167602/019fc97c-5ac3-709b-8fae-7e0d67f6c5e1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88OQz3LxwIcRvKGC18adSVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_1ceb3f46-104f-4acb-b9ae-44c78334ae4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97b-ffc7-749e-a9c1-9778942cbcbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97b-ffc7-749e-a9c1-9778942cbcbc",
        "storage_key": "property/6767906449167602/019fc97b-ffc7-749e-a9c1-9778942cbcbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6efa2631-13e4-4960-b99a-7561e26eae98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Rockhurst University",
      "poi_type": "Education",
      "poi_address": "1100 Rockhurst Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97b-fc41-71bf-adb3-c3ccc1b2d985.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97b-fc41-71bf-adb3-c3ccc1b2d985",
        "storage_key": "property/6767906449167602/019fc97b-fc41-71bf-adb3-c3ccc1b2d985.webp",
        "width": 960,
        "height": 320
      },
      "poi_business_url": "https://www.rockhurst.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16644960823377639958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockhurst-university",
      "poi_latitude": "39.0303478",
      "poi_longitude": "-94.5710674",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-501-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a0-7758-8b48-cabd72670ba1",
        "storage_key": "property/6767906449167602/019fc97c-57a0-7758-8b48-cabd72670ba1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU6rD5oTvwIcRFrq3Ga7H_uY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cc91da58-2c22-4394-802a-88650145a583",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Kansas City VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4801 Linwood Blvd, Kansas City, MO 64128, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-213a-7521-958e-3c0ed5874ab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-213a-7521-958e-3c0ed5874ab5",
        "storage_key": "property/6767906449167602/01a01015-213a-7521-958e-3c0ed5874ab5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.va.gov/kansas-city-health-care/locations/kansas-city-va-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5799742172005804653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-va-medical-center",
      "poi_latitude": "39.0633775",
      "poi_longitude": "-94.5269583",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 816-861-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57ad-745b-b9cf-3ede99f14bd2",
        "storage_key": "property/6767906449167602/019fc97c-57ad-745b-b9cf-3ede99f14bd2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZG7XSzlwIcRbSpC78bSfFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_227c0de7-6a72-41fd-a635-96c646831859",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "poi_name": "Research Medical Center ER of Brookside",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6601 Rockhill Rd, Kansas City, MO 64131, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01015-2162-7697-9658-676a6eaaddc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-2162-7697-9658-676a6eaaddc4",
        "storage_key": "property/6767906449167602/01a01015-2162-7697-9658-676a6eaaddc4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/research-medical-center-brookside-campus?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4540928133743379137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "research-medical-center-er-of-brookside",
      "poi_latitude": "39.0075704",
      "poi_longitude": "-94.5775679",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-276-7380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-57a9-7008-b3c4-4ebea64cf5b0",
        "storage_key": "property/6767906449167602/019fc97c-57a9-7008-b3c4-4ebea64cf5b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf4TUWnvwIcRwQJaKhSeBD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b2a4cf0a2ee1f49f3af0f17b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_295593fb129d5477578b6e5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_824610736c9cc10814abf478",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4d9bb40e1250313dcd6486fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_eec8beff818caaacc205eed6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_a07cb88d33a970f0bce60139",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "rating": "5",
      "name": "Page Hayley",
      "text": "I lived here for 6 months and had a really great experience. The management was eager to take care of any issue and the apartment was very clean and well-kept. The only minor thing was hearing my neighbor above me walk around but that was only occasionally and the rest of the time was super quiet. I felt safe in the neighborhood and parking was pretty good. Overall, a great experience and would happily live here again.",
      "date": "2018-09-19",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_ae6fa9f9b0ad6cf098cde95c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Studio apartment near KU Med at Malvern Hill Apartments in Kansas City, KS.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-cfe6-7439-8fd3-977a342d5d72.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0102a-cfe6-7439-8fd3-977a342d5d72",
        "storage_key": "property/6767906449167602/01a0102a-cfe6-7439-8fd3-977a342d5d72.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "STUDIO 1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3sK1u4P8Rjm"
    },
    {
      "id": "ec_2c8477955c211277b4123b5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Studio apartment near KU Med at Malvern Hill Apartments in Kansas City, KS.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-d010-754a-bb6a-1b93a950474a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0102a-d010-754a-bb6a-1b93a950474a",
        "storage_key": "property/6767906449167602/01a0102a-d010-754a-bb6a-1b93a950474a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "STUDIO 2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Z3is3jXf4GS"
    },
    {
      "id": "ec_d456a660ccf0a8e1e8896d9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "1-bedroom apartment near KU Med at Malvern Hill Apartments in Kansas City, KS.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a0102a-cf53-744a-8096-a66438ab20e8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0102a-cf53-744a-8096-a66438ab20e8",
        "storage_key": "property/6767906449167602/01a0102a-cf53-744a-8096-a66438ab20e8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Go38GEbjVyd"
    }
  ],
  "faqs": [
    {
      "id": "custom_f89f8abd-17d7-44a4-bc70-e635527027ba",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_860ec1e4-bfd8-4bd7-b6d9-099fe7df4e77",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_5be59bae-f762-4efb-8d36-33330581e154",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_3bc9bca0-f874-42da-b428-a57f81981ad0",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_420d263d-3289-45df-8aa2-198a52881fe6",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_1a1a927b-0d45-47b6-b7fe-ebe6ffcfa8a7",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_54473500-3c71-4b44-8964-e5ebaa3ae9f8",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_a4606acd-f2bc-44ee-8eb6-0c578d73b890",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our studio apartment homes, our residents are responsible to pay for water and trash. Our one and two bedroom apartment homes, our residents are responsible for electric, water, and trash.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8fb28d86-8e50-457a-9635-6f4a97e9699c",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b79adf35-efc5-4c7e-bdff-2fec503b2c9a",
      "question": " Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_c91c416d-7237-4cb8-9b4c-da46771810d7",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_bf299eb1-33ec-4835-837c-81bb059a4e88",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c3fc07bd-8f6b-44ac-a937-99e4eea2d2a5",
      "question": " Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_1f478073-27af-4139-9c72-fcb01e817ea0",
      "question": "Do you offer covered parking?",
      "answer": "We do offer limited garage parking. Please <a href=\"/contact-us\">contact the office</a> for our most current availability and pricing. We also free offer onsite parking with permit.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_88fa3f09-0dbb-4a2f-a26f-d7405711cc32",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_aa980d6d-c49a-4f86-bd1d-d9dfa66896d5",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_b2321bc8-9120-4938-ad8e-1dae40666efb",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3716-75aa-ab12-d811073a9f80",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Malvern Hill Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602"
    },
    {
      "lead_collector_id": "01a0c9ac-378b-7028-a2a0-9886ed837f26",
      "lead_source": "LANDING_PAGE",
      "name": "Malvern Hill Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "rosedale-kansas-city-off-street-parking-apartments",
      "search_query": "off-street parking apartments in Rosedale Kansas City",
      "category": "Amenity",
      "h1_title": "Off-Street Parking Apartments in Rosedale",
      "h2_subtitle": "Discover apartments with off-street parking in Rosedale. Malvern Hill offers comfort and convenience in the heart of Kansas City.",
      "page_copy": "Explore the convenience of off-street parking apartments in Rosedale, Kansas City, at Malvern Hill Apartment Homes. Our community provides both studio and one-bedroom layouts, designed with comfort and accessibility in mind. Enjoy seamless commutes with quick access to I-35 and visits to KU Medical Center just around the corner. Each apartment is cable ready and features ceiling fans for a comfortable living experience. \n\nResidents of Malvern Hill benefit from more than just off-street parking. Dive into our Pet Royalty Program and inquire about available garages for additional parking options. Nestled in the heart of Rosedale, our community offers a balance of urban convenience and neighborhood charm. Discover your new home and explore our available floor plans today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rosedale Apartments with Off-Street Parking",
      "seo_description": "Find Rosedale apartments with off-street parking at Malvern Hill. Enjoy community perks and great location near KU Medical Center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "wyandotte-county-apartments-stainless-steel-appliances",
      "search_query": "apartments with stainless steel appliances in Wyandotte County",
      "category": "Amenity",
      "h1_title": "Apt. with Stainless Steel Appliances in WyCo",
      "h2_subtitle": "Explore sleek apartments with stainless steel appliances in Wyandotte County. Discover modern living at Malvern Hill Apartment Homes.",
      "page_copy": "If you're searching for apartments with stainless steel appliances in Wyandotte County, look no further than Malvern Hill Apartment Homes. While our primary offerings feature studio and one-bedroom layouts with convenient access to amenities, we ensure the highest quality in design and function throughout all units. Even without stainless steel appliances, our kitchens remain stylish and practical, perfect for modern living in Kansas City.\n\nResiding in Malvern Hill provides seamless access to I-35 and the KU Medical Center, making it easy to balance work and leisure. Our community amenities include off-street parking, a Pet Royalty Program, and the option of garages, ensuring a lifestyle of convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in WyCo with Stainless Steel Appliances",
      "seo_description": "Discover Wyandotte County apartments with modern features. Malvern Hill provides stylish living spaces with key amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "ku-medical-center-pool-apartments",
      "search_query": "pool apartments near KU Medical Center",
      "category": "Amenity",
      "h1_title": "Pool Apartments Near KU Medical Center",
      "h2_subtitle": "Find relaxing pool apartments near KU Medical Center in Kansas City. Enjoy proximity and comfort at Malvern Hill Apartment Homes.",
      "page_copy": "While Malvern Hill Apartment Homes does not currently feature a pool, our unique offerings make us a top choice for those searching for pool apartments near KU Medical Center. Located in Rosedale, our community ensures easy access to local amenities and convenient commutes with quick connectivity to I-35. Our studio and one-bedroom layouts include modern comforts like ceiling fans and cable-ready systems.\n\nOur commitment is to provide a convenient and comfortable living experience near KU Medical Center. Our community perks include off-street parking, garage options, and a welcoming Pet Royalty Program, making your living experience at Malvern Hill both enjoyable and convenient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KU Med Center Pool Apartments",
      "seo_description": "Discover convenient living near KU Medical Center. Although we lack a pool, Malvern Hill offers key amenities in Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "malvern-hill-apartments-kansas-city-air-conditioning",
      "search_query": "Malvern Hill Apartments Kansas City with air conditioning",
      "category": "Amenity",
      "h1_title": "Malvern Hill Apartments with Air Conditioning",
      "h2_subtitle": "Enjoy comfort at Malvern Hill Apartments in Kansas City, featuring layouts that include air conditioning for your convenience.",
      "page_copy": "Malvern Hill Apartment Homes in Kansas City offers comfort and modern amenities in a prime Rosedale location. While air conditioning is a key feature in many apartments, our units are equipped with ceiling fans that complement natural, cool breezes. Located conveniently near I-35 and KU Medical Center, our studio and one-bedroom layouts are designed for your ease and comfort.\n\nAlong with climate comfort, Malvern Hill provides residents with off-street parking and an exclusive Pet Royalty Program. Discover our available garages as an added convenience and explore the local charm of Wyandotte County. If you're looking for well-designed living spaces in Kansas City with dependable climate solutions, Malvern Hill is the place to be.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Malvern Hill Apartments KC with A/C",
      "seo_description": "Discover Malvern Hill Apartments in Kansas City with climate comfort features like ceiling fans. Ideal location near I-35 and KU Medical Center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "kansas-city-dishwasher-equipped-apartments-66103",
      "search_query": "dishwasher-equipped apartments in Kansas City 66103",
      "category": "Amenity",
      "h1_title": "Dishwasher Apartments in Kansas City 66103",
      "h2_subtitle": "Discover dishwasher-equipped apartments in Kansas City, 66103. While Malvern Hill doesn't have dishwashers, find exceptional living with us.",
      "page_copy": "Searching for dishwasher-equipped apartments in Kansas City, 66103? Consider Malvern Hill Apartment Homes as an alternative. Although we do not currently offer in-unit dishwashers, our studios and one-bedroom units are designed with functionality in mind. Situated in the heart of Rosedale, we guarantee quick access to KU Medical Center and downtown Kansas City, alongside effortless urban living.\n\nOur community encourages a comfortable lifestyle with amenities like off-street parking, optional garages, and a dedicated Pet Royalty Program. At Malvern Hill, residents enjoy the ease of cable-ready homes and ceiling fans for enhanced comfort, ensuring you feel right at home in one of Kansas City’s most convenient locations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KC Apartments 66103 with Dishwasher Options",
      "seo_description": "Explore Kansas City 66103 living at Malvern Hill. While dishwashers aren't available, enjoy convenient amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "studio-apartments-rosedale-kansas-city",
      "search_query": "studio apartments rosedale kansas city",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Rosedale, Kansas City",
      "h2_subtitle": "Explore studio apartments in Rosedale, Kansas City. Malvern Hill offers modern living with easy access to downtown and KU Medical Center.",
      "page_copy": "If you're exploring studio apartments in Rosedale, Kansas City, Malvern Hill Apartment Homes makes an excellent choice. Our studios are designed to provide a functional and comfortable living space close to KU Medical Center and downtown. Enjoy seamless trips with nearby I-35 access and indulge in local conveniences.\n\nMalvern Hill complements your urban lifestyle with essential amenities like off-street parking and a Pet Royalty Program that welcomes your furry friends. Our ceiling fans enhance comfort in every room, and with cable-ready connections, you're set up for seamless online streaming. Discover your new home in the thriving Rosedale neighborhood today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Rosedale KC",
      "seo_description": "Find studio apartments in Rosedale, Kansas City. Malvern Hill offers modern amenities and prime access to KU Medical Center and downtown.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-wyandotte-county-ks",
      "search_query": "one bedroom apartments wyandotte county ks",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Wyandotte County, KS",
      "h2_subtitle": "Discover one bedroom apartments in Wyandotte County, KS, at Malvern Hill. Enjoy urban accessibility and contemporary conveniences in Rosedale.",
      "page_copy": "Experience modern living at Malvern Hill Apartment Homes with our one bedroom apartments in Wyandotte County, KS. Nestled in the vibrant Rosedale area, these apartments provide residents with an ideal blend of comfort and convenience, being just minutes from the KU Medical Center and I-35. Whether it's a quick commute to downtown Kansas City or exploring local hotspots, Malvern Hill makes it easy.\n\nOur community thoughtfully provides amenities such as off-street parking and garages, ensuring your vehicle is always secure. Pet owners will appreciate our unique Pet Royalty Program, welcoming pets into this friendly community. With cable-ready units and ceiling fans enhancing comfort, our one bedroom layouts invite you to a tranquil and connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Wyandotte County KS",
      "seo_description": "Discover Malvern Hill's one bedroom apartments in Rosedale, Wyandotte County, KS. Enjoy modern amenities and quick downtown access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-near-frank-rushton-elementary-kc",
      "search_query": "apartments near Frank Rushton Elementary Kansas City",
      "category": "School",
      "h1_title": "Apartments Near Frank Rushton Elementary KC",
      "h2_subtitle": "Explore apartments near Frank Rushton Elementary in Kansas City. Malvern Hill offers convenience and a welcoming community.",
      "page_copy": "Looking for apartments near Frank Rushton Elementary in Kansas City? Malvern Hill Apartment Homes provides a perfect option, offering proximity to quality education and a vibrant community. Located in Rosedale, residents benefit from quick access to the KU Medical Center and downtown, making day-to-day commuting and errands easy.\n\nOur community is designed with residents in mind, featuring amenities like off-street parking and available garages, ensuring a hassle-free living experience. We also offer a Pet Royalty Program for your cherished furry friends, making Malvern Hill a truly welcoming community. Experience the convenience of our cable-ready apartments with ceiling fans that add an extra touch of comfort in every room.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Frank Rushton Elementary KC",
      "seo_description": "Discover Malvern Hill Apartments near Frank Rushton Elementary in Kansas City, offering prime location and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "malvern-hill-apartments-near-rosedale-middle-school",
      "search_query": "Malvern Hill apartments near Rosedale Middle School",
      "category": "School",
      "h1_title": "Malvern Hill Apartments Near Rosedale Middle School",
      "h2_subtitle": "Discover Malvern Hill Apartments perfectly located near Rosedale Middle School, offering a blend of comfort and convenience in Kansas City.",
      "page_copy": "Malvern Hill Apartment Homes is located near Rosedale Middle School, in the heart of the Rosedale neighborhood. Situated in the heart of the Rosedale neighborhood, our community offers the ease of close proximity to educational institutions while being connected to the vibrant Kansas City lifestyle. Quickly access downtown and the KU Medical Center via I-35, making commutes and casual outings both swift and simple.\n\nOur community provides features that cater to every lifestyle. Enjoy hassle-free living with off-street parking and available garages. Pet owners will love our unique Pet Royalty Program, establishing Malvern Hill as a pet-friendly haven. Each apartment is equipped with ceiling fans and cable-ready setups, ensuring comfort and connectivity for all residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Malvern Hill Apts Near Rosedale Middle School",
      "seo_description": "Malvern Hill Apartments, near Rosedale Middle School in Kansas City, offers comfort, convenience, and excellent community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "ta-edison-elementary-school-nearby-apartments",
      "search_query": "T.A. Edison Elementary School nearby apartments in Rosedale",
      "category": "School",
      "h1_title": "Nearby Apartments to T.A. Edison Elementary School",
      "h2_subtitle": "Find apartments near T.A. Edison Elementary in Rosedale. Malvern Hill Apartment Homes offers convenience and quality living.",
      "page_copy": "Malvern Hill Apartment Homes is located near T.A. Edison Elementary School in Rosedale. Located in a vibrant neighborhood, our community offers access to excellent educational facilities while being close to Kansas City's dynamic urban core. Quick access to I-35 ensures a swift commute to downtown and the KU Medical Center.\n\nEnjoy community perks like off-street parking and the option of garages, designed for optimal convenience. For pet lovers, our exclusive Pet Royalty Program creates a welcoming environment alongside other excellent amenities like cable readiness and ceiling fans in each unit. Discover the blend of comfort and accessibility at Malvern Hill Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near T.A. Edison Elementary School",
      "seo_description": "Explore Malvern Hill Apartments, close to T.A. Edison Elementary School in Rosedale, offering a prime location and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "jc-harmon-high-school-wyandotte-county-apartments",
      "search_query": "J.C. Harmon High School Wyandotte County apartments",
      "category": "School",
      "h1_title": "Apartments Near J.C. Harmon High School",
      "h2_subtitle": "Explore Wyandotte County apartments near J.C. Harmon High School. Malvern Hill offers prime living in the Rosedale area.",
      "page_copy": "Positioned in the vibrant community of Rosedale, Malvern Hill Apartment Homes is a great choice for anyone looking for apartments close to J.C. Harmon High School in Wyandotte County. Our location provides easy access to educational opportunities while being minutes away from downtown Kansas City and the KU Medical Center.\n\nExperience the perks of community living with features like off-street parking and the availability of garages. Our pet-friendly policies include a unique Pet Royalty Program, ensuring all family members feel welcomed. Inside each apartment, residents enjoy cable readiness and ceiling fans, making life at Malvern Hill both comfortable and convenient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near J.C. Harmon High School in Wyandotte",
      "seo_description": "Discover Malvern Hill Apts, ideally located near J.C. Harmon High School in Wyandotte County, offering a blend of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-near-westwood-view-elementary-school",
      "search_query": "apartments near Westwood View Elementary School KS",
      "category": "School",
      "h1_title": "Apartments Near Westwood View Elementary KS",
      "h2_subtitle": "Find Kansas apartments near Westwood View Elementary School. Malvern Hill offers comfortable living in the Rosedale neighborhood.",
      "page_copy": "Malvern Hill Apartment Homes offers apartments near Westwood View Elementary School in Kansas. Located in the lively Rosedale neighborhood, our community not only provides proximity to quality education but also ensures quick access to major highways and downtown Kansas City.\n\nOur amenities are tailored to enhance everyday living, featuring off-street parking and available garages for added convenience. Pet owners can benefit from our Pet Royalty Program, welcoming pets as part of the family. Each apartment comes cable-ready and equipped with ceiling fans, making Malvern Hill a comfortable and modern place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Westwood View Elementary School KS",
      "seo_description": "Explore Malvern Hill Apartments near Westwood View Elementary School, KS. Enjoy modern amenities and a prime location in Rosedale.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "kansas-city-kansas-community-college-apartments-66103",
      "search_query": "Kansas City Kansas Community College apartments in 66103",
      "category": "School",
      "h1_title": "Apartments Near Kansas City Kansas Community College",
      "h2_subtitle": "Discover comfortable living in 66103 with apartments near Kansas City Kansas Community College. Malvern Hill offers convenient access.",
      "page_copy": "For students and staff seeking convenient housing near Kansas City Kansas Community College, Malvern Hill Apartment Homes in the 66103 area code provides an excellent choice. Situated in the heart of Rosedale, our community is positioned perfectly between higher education and city amenities, offering quick access to I-35 and downtown Kansas City.\n\nResidents will enjoy the practical benefits of off-street parking and optional garages, alongside our inviting Pet Royalty Program that welcomes furry friends. Our apartments boast features like cable readiness and ceiling fans, providing a comfortable environment for study and relaxation. Explore what makes Malvern Hill a standout choice for college living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near KC Kansas Community College in 66103",
      "seo_description": "Find ideal living at Malvern Hill Apartments near Kansas City Kansas Community College, 66103. Enjoy convenience and great amenities in Rosedale.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-art-institute",
      "search_query": "apartments near Kansas City Art Institute",
      "category": "School",
      "h1_title": "Apartments Near Kansas City Art Institute",
      "h2_subtitle": "Live creatively in Rosedale with apartments near Kansas City Art Institute. Malvern Hill fosters artistic living with modern perks.",
      "page_copy": "Artists and students looking for apartments near Kansas City Art Institute will find Malvern Hill Apartment Homes an inspiring choice. Nestled in the Rosedale neighborhood, our community offers a peaceful yet vibrant environment conducive to artistic pursuits. The convenient location provides quick access to both the art institute and downtown Kansas City's cultural activities.\n\nOur studio and one-bedroom apartments are perfect for creative thinkers, featuring essential amenities such as off-street parking, garages, and a unique Pet Royalty Program. Each unit comes cable ready and includes ceiling fans, creating a comfortable setting that caters to both work and leisure. Discover how Malvern Hill blends artful living with convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Kansas City Art Institute",
      "seo_description": "Explore Malvern Hill Apartments near Kansas City Art Institute. Perfect blend of artful living and modern amenities in Rosedale.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "umkc-nearby-rosedale-apartments",
      "search_query": "University of Missouri-Kansas City nearby Rosedale apartments",
      "category": "School",
      "h1_title": "UMKC Nearby Rosedale Apartments",
      "h2_subtitle": "Convenient Rosedale living near University of Missouri-Kansas City. Discover Malvern Hill’s comfortable and accessible apartment options.",
      "page_copy": "For students and faculty searching for University of Missouri-Kansas City nearby Rosedale apartments, Malvern Hill Apartment Homes offer a perfect solution. Ideally located close to UMKC, our community provides a hassle-free commute and easy access to the academic hub of Kansas City.\n\nResidents enjoy a host of amenities, including off-street parking and available garage spaces, making life easy and efficient. Our Pet Royalty Program ensures that all pets feel at home too. Each apartment is cable ready and fitted with ceiling fans, creating an atmosphere that's both welcoming and functional. Experience the blend of convenience and comfort that Malvern Hill offers aspiring professionals and academics alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "UMKC Nearby Rosedale Apts | Malvern Hill",
      "seo_description": "Discover Malvern Hill Apartments near UMKC in Rosedale. Convenient, comfortable living with great access to university life and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "rockhurst-university-kansas-city-apartments-close-by",
      "search_query": "Rockhurst University Kansas City apartments close by",
      "category": "School",
      "h1_title": "Apartments Close to Rockhurst University",
      "h2_subtitle": "Find ideal living near Rockhurst University in Kansas City. Malvern Hill offers a vibrant community with easy campus access.",
      "page_copy": "Looking for apartments close by Rockhurst University in Kansas City? Malvern Hill Apartment Homes offers students and staff an inviting community just a quick drive from campus. Located in the neighborhood of Rosedale, our apartments provide a convenient and comfortable living experience within reach of academic resources and city life.\n\nOur studio and one-bedroom layouts are designed with efficiency and comfort in mind, featuring amenities like off-street parking, garages, and a welcoming Pet Royalty Program. Each apartment is cable-ready and includes ceiling fans, ensuring a pleasant environment suitable for both study and relaxation. Discover why Malvern Hill is the perfect place to balance university life with modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Rockhurst University KC | Malvern Hill",
      "seo_description": "Explore Malvern Hill Apartments close to Rockhurst University in KC. Comfort and convenience await students and staff in Rosedale.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-near-university-of-kansas-hospital-rosedale",
      "search_query": "apartments near university of kansas hospital rosedale",
      "category": "Hospital",
      "h1_title": "Apartments Near University of Kansas Hospital",
      "h2_subtitle": "Discover ideal apartments near University of Kansas Hospital in Rosedale. Malvern Hill offers convenience and comfort.",
      "page_copy": "For those seeking apartments near University of Kansas Hospital in Rosedale, Malvern Hill Apartment Homes provide an exceptional location. Situated just moments away, our community offers easy access to the hospital, making it perfect for medical professionals and students alike.\n\nOur selection of studio and one-bedroom apartments is designed to meet the needs of busy lifestyles, featuring amenities like off-street parking, garage availability, and a Pet Royalty Program that welcomes your furry companions. Every unit comes cable ready and with ceiling fans, creating a comfortable living environment. Choose Malvern Hill for a harmonious blend of proximity and quality living in Rosedale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near KU Hospital Rosedale | Malvern Hill",
      "seo_description": "Find convenient, comfortable apartments near University of Kansas Hospital in Rosedale at Malvern Hill. Perfect for medical professionals and students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-close-to-university-health-truman-medical-center-kansas-city",
      "search_query": "apartments close to university health truman medical center kansas city",
      "category": "Hospital",
      "h1_title": "Apts Close to University Health Truman Medical",
      "h2_subtitle": "Explore Malvern Hill for apartments close to University Health Truman Medical Center in Kansas City, offering convenience and excellent amenities.",
      "page_copy": "Searching for apartments close to University Health Truman Medical Center in Kansas City? Malvern Hill Apartment Homes provides the perfect location for healthcare professionals and students with its strategic positioning in Rosedale, offering a quick commute to the medical center.\n\nOur community features practical studio and one-bedroom layouts complemented by convenient amenities like off-street parking, garages, and a welcoming Pet Royalty Program. Each apartment is cable ready and equipped with ceiling fans, ensuring a comfortable atmosphere ideal for unwinding after a day at the medical center. Experience the ease and quality of life at Malvern Hill, just minutes from University Health Truman Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Truman Medical Center KC | Malvern Hill",
      "seo_description": "Discover Malvern Hill Apartments near University Health Truman Medical Center in Kansas City. Convenient living with top amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-near-childrens-mercy-adele-hall-campus-wyandotte-county",
      "search_query": "apartments near children's mercy adele hall campus wyandotte county",
      "category": "Hospital",
      "h1_title": "Apts Near Children's Mercy Adele Hall",
      "h2_subtitle": "Discover apartments near Children's Mercy Adele Hall Campus in Wyandotte County, offering convenience and quality living at Malvern Hill.",
      "page_copy": "If you're seeking apartments near Children's Mercy Adele Hall Campus in Wyandotte County, Malvern Hill Apartment Homes is the perfect place to call home. Located in the vibrant Rosedale neighborhood, our community provides a convenient location for anyone who needs to be close to the hospital.\n\nThe studio and one-bedroom apartments at Malvern Hill boast practical features, including off-street parking, optional garages, and a delightful Pet Royalty Program. Each unit is cable-ready and has ceiling fans, ensuring a well-rounded living environment that caters to both relaxation and functionality. Make Malvern Hill your new home for easy access to Children's Mercy Adele Hall Campus and a balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Children's Mercy Adele Hall | Malvern Hill",
      "seo_description": "Live close to Children's Mercy Adele Hall Campus in Wyandotte County. Malvern Hill offers convenient, quality apartments near the hospital.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-close-to-kansas-city-va-medical-center-66103",
      "search_query": "apartments close to kansas city va medical center 66103",
      "category": "Hospital",
      "h1_title": "Apts Close to Kansas City VA Medical Center",
      "h2_subtitle": "Find your new home at Malvern Hill, offering apartments close to Kansas City VA Medical Center in the 66103 area. Enjoy convenience and comfort.",
      "page_copy": "For those looking for apartments close to Kansas City VA Medical Center in the 66103 area, Malvern Hill Apartment Homes is an ideal choice. Nestled in the heart of Rosedale, this community provides easy access to the VA Medical Center, making it convenient for anyone working at or visiting the medical center.\n\nMalvern Hill offers both studio and one-bedroom options equipped with essential amenities like off-street parking and available garages. The residence is cable ready and features ceiling fans for year-round comfort. Additionally, our Pet Royalty Program welcomes pets, making it a great choice for those with companion animals. Choose Malvern Hill for proximity and quality living near Kansas City VA Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to KC VA Medical Center 66103 | Malvern Hill",
      "seo_description": "Convenient living awaits at Malvern Hill Apartments, close to Kansas City VA Medical Center in the 66103 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-near-rosedale-park-kansas-city",
      "search_query": "apartments near Rosedale Park Kansas City",
      "category": "Park",
      "h1_title": "Apts Near Rosedale Park Kansas City",
      "h2_subtitle": "Discover vibrant living at Malvern Hill, with apartments near Rosedale Park in Kansas City. Enjoy nature and urban convenience.",
      "page_copy": "If you're searching for apartments near Rosedale Park in Kansas City, look no further than Malvern Hill Apartment Homes. Located in the lively neighborhood of Rosedale, our community provides both the charm of natural surroundings and the perks of urban living.\n\nMalvern Hill Apartment Homes offers studio and one-bedroom options with amenities such as off-street parking, garages, and a one-of-a-kind Pet Royalty Program, ensuring a pet-friendly environment. Each unit is cable-ready and features ceiling fans to keep you comfortable. Enjoy a perfect blend of tranquility and accessibility with Malvern Hill as your base for both leisure at Rosedale Park and city adventures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Rosedale Park KC | Malvern Hill",
      "seo_description": "Live near Rosedale Park at Malvern Hill Apartments in Kansas City. Enjoy easy access to green spaces and urban amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "malvern-hill-apartments-close-to-fisher-park",
      "search_query": "Malvern Hill apartments close to Fisher Park",
      "category": "Park",
      "h1_title": "Malvern Hill Apts Near Fisher Park",
      "h2_subtitle": "Enjoy life at Malvern Hill Apartments, conveniently located close to Fisher Park. Experience comfort and nature in Kansas City.",
      "page_copy": "For those seeking an apartment close to Fisher Park, Malvern Hill Apartment Homes offers an outstanding location in Kansas City. Situated in the charming Rosedale neighborhood, you're just a short distance from the serene setting of Fisher Park, perfect for outdoor activities and relaxation.\n\nOur studio and one-bedroom apartments are designed with essential amenities, including off-street parking, cable readiness, and available garages. Our unique Pet Royalty Program ensures that even your furry friends feel at home. With ceiling fans enhancing comfort year-round, Malvern Hill provides a welcoming atmosphere just moments away from Fisher Park's natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Malvern Hill Apts Near Fisher Park | Kansas City",
      "seo_description": "Experience comfort at Malvern Hill Apartments near Fisher Park. Enjoy the blend of nature and convenience in Kansas City's Rosedale neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "kansas-city-apartments-by-berkley-riverfront",
      "search_query": "Kansas City apartments by Berkley Riverfront",
      "category": "Park",
      "h1_title": "KC Apartments by Berkley Riverfront",
      "h2_subtitle": "Discover comfortable living at Malvern Hill, Kansas City apartments conveniently located by Berkley Riverfront. Enjoy scenic urban views.",
      "page_copy": "For a perfect blend of urban lifestyle and scenic beauty, Malvern Hill Apartment Homes is your ideal choice among Kansas City apartments by Berkley Riverfront. Located in the vibrant Rosedale area, our community offers quick access to downtown and the calming vistas of the riverfront.\n\nChoose from our stylish studio and one-bedroom apartments, complete with features like off-street parking and garages. Each apartment provides a cable-ready living space and ceiling fans, ensuring a comfortable environment year-round. The Pet Royalty Program welcomes pets, making Malvern Hill a pet-friendly community where you can fully embrace Kansas City's outdoor offerings near Berkley Riverfront.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KC Apartments by Berkley Riverfront | Malvern Hill",
      "seo_description": "Live comfortably near Berkley Riverfront at Malvern Hill Apartments in Kansas City. Experience urban life and scenic views in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "malvern-hill-rentals-near-kaw-point-park",
      "search_query": "Malvern Hill rentals near Kaw Point Park",
      "category": "Park",
      "h1_title": "Malvern Hill Rentals by Kaw Point Park",
      "h2_subtitle": "Experience the convenience of Malvern Hill rentals near Kaw Point Park. Enjoy proximity to nature and city life in Kansas City.",
      "page_copy": "Are you searching for the perfect rentals near Kaw Point Park? Malvern Hill Apartment Homes offers a prime location in Kansas City with easy access to this natural haven. Nestled in the charming Rosedale neighborhood, Malvern Hill combines the tranquility of nearby green spaces with the vibrancy of city living.\n\nOur community provides well-appointed studio and one-bedroom rentals featuring essential amenities such as off-street parking and the option of garages. Residents enjoy cable-ready units with ceiling fans, contributing to a comfortable living experience. Plus, our unique Pet Royalty Program ensures a warm welcome for your four-legged companions. Discover the joys of living just minutes from Kaw Point Park at Malvern Hill.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Malvern Hill Rentals Near Kaw Point Park KC",
      "seo_description": "Find your ideal home at Malvern Hill rentals near Kaw Point Park. Blend nature and urban conveniences in Kansas City's Rosedale area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-near-jersey-creek-park-wyandotte-county",
      "search_query": "apartments near Jersey Creek Park in Wyandotte County",
      "category": "Park",
      "h1_title": "Apartments by Jersey Creek Park",
      "h2_subtitle": "Explore Malvern Hill Apartments near Jersey Creek Park in Wyandotte County. Embrace comfort and nature in Kansas City's Rosedale.",
      "page_copy": "Looking for apartments near Jersey Creek Park in Wyandotte County? Malvern Hill Apartment Homes offers an ideal location for those who cherish the outdoors and city convenience. Situated in the vibrant Rosedale neighborhood, you're just a stone's throw from the beautiful Jersey Creek Park, perfect for leisurely strolls and outdoor activities.\n\nOur studio and one-bedroom apartments are designed to offer practical amenities such as off-street parking and garages. Residents enjoy modern comforts like cable readiness and ceiling fans, complemented by our unique Pet Royalty Program that ensures a pet-friendly environment. Malvern Hill provides a serene yet connected living experience in close proximity to Jersey Creek Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Jersey Creek Park | Malvern Hill",
      "seo_description": "Discover Malvern Hill Apartments near Jersey Creek Park in Wyandotte County. Comfortable living meets outdoor relaxation in Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167602",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-airport-rosedale",
      "search_query": "apartments near kansas city international airport rosedale",
      "category": "Transit",
      "h1_title": "Rosedale Apartments Near Kansas City Airport",
      "h2_subtitle": "Find comfort at Malvern Hill Apartments near Kansas City International Airport, nestled in the Rosedale neighborhood.",
      "page_copy": "Malvern Hill Apartment Homes offers a prime location among apartments near Kansas City International Airport, providing easy access for frequent travelers and city adventurers alike. Positioned in the charming Rosedale neighborhood, our community ensures you're never far from flight conveniences and local attractions.\n\nChoose from our selection of studio and one-bedroom layouts, each equipped with essential amenities such as off-street parking and garages. Residents also enjoy modern conveniences like cable-ready units and ceiling fans. Our Pet Royalty Program ensures your furry friends feel at home too. Experience the ease of living near Kansas City International Airport, with the comforts of Malvern Hill.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a sunset sky",
        "public_id": "019fc97d-83c2-71ac-9443-839a6567408f",
        "storage_key": "property/6767906449167602/019fc97d-83c2-71ac-9443-839a6567408f.webp",
        "width": 1200,
        "height": 801
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rosedale Apts Near Kansas City Airport | Malvern Hill",
      "seo_description": "Malvern Hill offers comfortable living in Rosedale, near Kansas City International Airport. Ideal for travelers seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701864751"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NRMHSVX6"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/6345a3d3-e60f-473f-abd6-81c685437ee1/app.js?nocache=1&gaTracking=G-E3VRMRS74W&buttonbgcolor=8dbad7&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-382-2957"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkxmZGw3bjRaeElwVjF2QTMwZ2JCT0E9PSIsInZhbHVlIjoiaTU5UW1WVFJWdnlvQWdVL1JXd1FrZz09IiwibWFjIjoiZGM5ZWJmNDVjODczMDY5YmI1Y2RhNTk3YmQzNzUwZDAxY2Q3ZDFmNGRkNDJlNDA0NDUzNzE5MjhjZmRjNGNlNiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701864751",
  "custom_google_gtm_id": "GTM-NRMHSVX6",
  "custom_rollout_phase": "Batch 2",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/6345a3d3-e60f-473f-abd6-81c685437ee1/app.js?nocache=1&gaTracking=G-E3VRMRS74W&buttonbgcolor=8dbad7&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-382-2957",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkxmZGw3bjRaeElwVjF2QTMwZ2JCT0E9PSIsInZhbHVlIjoiaTU5UW1WVFJWdnlvQWdVL1JXd1FrZz09IiwibWFjIjoiZGM5ZWJmNDVjODczMDY5YmI1Y2RhNTk3YmQzNzUwZDAxY2Q3ZDFmNGRkNDJlNDA0NDUzNzE5MjhjZmRjNGNlNiJ9",
  "custom_audioeye_site_id": "52f79ae7-9cc2-44fd-b4d1-b6e4e44a1750",
  "custom_audioeye_site_hash": "e835962bbce018a8264026819b8ecf06"
};

export const generatedAt = '2026-11-03T23:00:42.471Z';
